/**
 * Reverse lookup map for JobCode RefIds
 * Maps RefId (GUID) -> JobCode
 */

export const JOB_CODE_REVERSE_LOOKUP: Map<string, string> = new Map([
    ['B52FEE45-3B03-4F3C-A43E-7A02B367A3D5', '0020'],
    ['950EB5C4-2CBB-4401-B861-C7D27FAC7528', '0025C'],
    ['696B9B43-63D7-4064-9BBB-3AA889CD3CE2', '0025PT'],
    ['5F44BD7F-4415-4DB8-AA6B-5280F56E9B2C', '0204PT'],
    ['F73A84D7-D0A4-4F60-AADB-7A8B0772D713', 'A510'],
    ['1416F14F-0654-48EE-BFB2-275C6019A63D', 'A510MA'],
    ['2F9B2001-6890-437F-9288-3F08BCB01343', 'A512PT'],
    ['A4121F1D-4980-44EC-92A7-F57BD4E8DAF9', 'A515MA'],
    ['8F3F7EFB-5ADA-49B7-AABB-47AD6E3ED09F', 'A51GMA'],
    ['B0F078A9-99D8-447C-A7DD-C623347848A5', 'A51MPT'],
    ['B8ED1363-0FD6-4E59-954F-5BF0450408B2', 'A520MA'],
    ['CC48E853-16DB-474F-B067-91AB3C800771', 'A521'],
    ['76609412-FF11-4838-ACE2-AB1FE951191A', 'A521MA'],
    ['71252F26-3661-4363-B6BF-A8BA3B8F53EF', 'A524PT'],
    ['6F2FB464-5AFC-4226-81CA-FFF980EBF3C5', 'A525PT'],
    ['EE058DBD-D9C4-4DB6-B4A8-363E32D7DFE8', 'A527PT'],
    ['CBB7B2ED-58C8-4589-A3F4-C62296879D87', 'E026'],
    ['A9582600-B86E-48B1-B74B-7853AE088CE5', 'E027'],
    ['B8F7A19F-1F3C-4FF4-BB8A-B8E67B620116', 'E033'],
    ['25217173-EABE-4E73-B9E7-15FCD5FFB4B8', 'E042PT'],
    ['2A712ED7-09DB-42FE-A7EB-27F76D616F4D', 'E167PT'],
    ['8F296E0F-BAD9-4CC4-A192-3A9AB869A204', 'E212MA'],
    ['A97126C9-FB96-460A-829C-9E80F5D20425', 'E213PT'],
    ['6AA002DE-BD53-42DC-8DE7-08C21062B1DA', 'E214'],
    ['A0848683-FB7C-4D50-A805-1C5C05DE146C', 'E303MA'],
    ['AA172D07-2625-4DD4-B94C-7E3C6537DB2C', 'Magnet'],
    ['455D3FD4-28C0-4625-920C-86A4CD30A4F0', 'NN57MA'],
    ['81574C73-A79F-4167-9B95-1BAA776A8B74', 'NN61'],
    ['7C06D541-91DF-4910-A43E-E92D1EDFE9B4', 'NN66'],
    ['31D39716-5A26-4789-85FB-7E29DC73FDC8', 'NN70'],
    ['56FC2448-5773-459A-B546-B2633CB63B42', 'NN75MA'],
    ['93556059-949B-4FCB-B78C-3A580C453185', 'NN92'],
    ['6B479865-F8EC-4DB9-BAB1-FA7A78AA2CDD', 'Pre-IB Math'],
    ['CB9F8A73-20BB-41EB-9845-97396267FC9A', 'S005'],
    ['8239EC3E-97B3-4E2E-9816-D23456D01BDC', 'S005MA'],
    ['954153E6-C7C3-4A81-8622-C8C11B4E5544', 'S011PT'],
    ['CB897634-E06B-4C5E-872F-B6D591F137EA', 'S017'],
    ['82A29D45-EC52-40F9-8782-226DCA9B8658', 'S017MA'],
    ['AD109AF7-C290-4C8B-B742-BD8192383463', 'S017PT'],
    ['4D8749E4-B581-4BA6-8698-B4CE094B0E0D', 'S018MA'],
    ['F149CA76-13C4-4E72-9165-713BB9E55A43', 'S023MA'],
    ['05AFFD94-77EA-43FA-873D-625B1EFEA0D3', 'S024'],
    ['8C4F12D8-952A-4FD9-8F4D-21B9D3B76B4F', 'S025'],
    ['9D77D901-E923-451C-9515-0E612FA7380C', 'S027'],
    ['D9429517-8E00-4F01-8DAF-76C24B77F81F', 'S030MA'],
    ['15F8238D-BB7E-4F69-AAC8-FA95B82823A3', 'S032'],
    ['BAE344AB-7497-4F09-98F3-A693E6FF4D29', 'S045PT'],
    ['A1314BAE-1608-4489-9CD7-A3AC1F2D2641', 'S049'],
    ['626A2579-7792-4032-9A76-A03F7A38538B', 'S049MASS'],
    ['B3A5C8AD-5D2E-4A8A-BCE9-FDD1A3B6EF5A', 'S061'],
    ['302A547F-F002-4386-B267-2E6B8425C1CC', 'S075PT'],
    ['59B47F67-029C-467E-B56D-FF1CE4F0E36E', 'S113'],
    ['549E9D6C-5249-4F5A-9954-EACC8C831794', 'S121'],
    ['8CC3A38A-16D0-4B5D-BC8E-0FCDCA92B542', 'S123PT'],
    ['62EE06BC-1213-4E42-9FCC-5CAC29A94C33', 'S126'],
    ['ECECC979-9CE9-41DA-93E3-5A7C1D33A8AE', 'S129'],
    ['DAD22591-BFD2-41E7-BD6F-5151B364937A', 'S150MA'],
    ['4F329FBA-CC13-4CF6-B6C8-4F2DFEED8461', 'S161H'],
    ['10824896-703E-481C-B7DD-E010F0B2F7A5', 'S162H'],
    ['DAB6A4FA-23AE-409B-B5BE-C048560E763B', 'S163A'],
    ['1CAF9E6C-12D6-4A8D-A5CB-10FF1F160C40', 'S163H'],
    ['73DD49B5-F958-474F-A174-7D03AE24D85D', 'S213PT'],
    ['EFEB9C63-A7BD-4C85-82C0-16459707012A', 'S233MA'],
    ['0848CB11-5CB3-43B7-AF24-19E5A17F016E', 'S242PT'],
    ['A05F6C8A-F912-4FE5-A30B-45852971DBD9', 'S262'],
    ['0BEBA221-0CA0-4B4B-B6E7-F099A79712EB', 'S300CMA'],
    ['485285E5-BE6D-457D-8AA6-743ACB7E4E94', 'S301BMA'],
    ['3AF03902-F14A-4FBF-8237-7785C2DFBA9D', 'S309'],
    ['A30C9E9A-CB23-4792-B80D-6C36E12D51B6', 'S512MA'],
    ['8054AABD-0CE8-4161-812D-E0D7FC7C91D6', 'S681PT'],
    ['545DF0C7-C7CC-498C-84BB-C9B1324FC182', 'S701'],
    ['A981B680-F451-4BAE-96B5-5BF14B5F0EBB', 'S713PT'],
    ['4CB172AF-797B-4996-9635-86E1E33FDE7D', 'S736'],
    ['9499E409-A3D2-4749-AD70-BA7D33E0D40E', 'S763PT'],
    ['84632DED-A67D-49DD-AC02-C967A8298069', 'S804PT'],
    ['96798A6D-8E74-474E-8DE5-EA49196A4F0D', 'S809PT'],
    ['9152F058-19D6-4BD9-A814-6A3E73B2F894', 'S810PT'],
    ['D25374ED-7D0D-4A54-8449-F611E84B34B5', 'S813PT'],
    ['04775F59-23CD-44FA-9CEF-1376902D9FF9', 'S815'],
    ['2F3AD6CF-F60F-433D-AFC8-AB202E780B3E', 'S840'],
    ['78E38146-C0FD-4C24-BC67-338CBE9A268B', 'S841'],
    ['BD4E6681-337C-4CB0-AB38-838452F01330', 'S862'],
    ['BD1023CB-CC6B-4314-98A7-36634AC6954F', 'S881'],
    ['42AB3294-B08F-4E91-BA88-70AE7CB1A140', 'S890PT'],
    ['7C7DC94A-BA6C-47D1-A345-304BF62C1821', 'S912'],
    ['DDBC8B5F-A18C-4A45-B4B3-730331792134', '0207'],
    ['53ED580A-BD24-4B53-9E7E-A96AA612BD84', '0209'],
    ['15F798FB-6417-40D5-BAFB-1504F3FEDEB7', '0223R'],
    ['9628E6C0-A14D-41C4-8F08-4203ED44FC24', '0224PT'],
    ['A3DB3A7A-6811-486A-AE61-6DB48C8312E6', '0226PT'],
    ['594DFE9F-E39C-42C0-B6BF-8A6054665E74', '0227PT'],
    ['94A05C59-D48F-4449-ADC6-07DCB7B18ADC', '0229'],
    ['F38DD81F-0E43-4B0E-A22D-09E94D75E80A', '0302'],
    ['8FB93B71-8113-4CC5-984B-B61D6133888E', '0330'],
    ['98365417-798B-4645-953B-FFC1B173E15B', '0330PT'],
    ['9EC7CB33-5006-42C9-A5AB-2649FE5984CA', '0335PT'],
    ['2A6D1BEF-8DB4-4CA1-B915-446CDBFA45A4', '0340PT'],
    ['D49B1BC0-F694-409C-949E-06C357BEB0A8', '0341MA'],
    ['9C958B2E-A035-4B8F-A044-FA3FF79611BF', '0341MASS'],
    ['765251E3-E0A6-4455-8D38-8BE464EE3534', '0355PT'],
    ['2DC32FFF-A238-455F-BB8C-A5886425476B', '0356PT'],
    ['B216A134-89A8-42BB-A4AF-5EECD7DAE267', '0357'],
    ['CDA26151-4CEB-4750-B729-16F578AC1BCA', '0357MASS'],
    ['95238E94-5637-4A34-88C7-0B6F594B159A', '0358MASS'],
    ['13378111-FA18-4CF3-BEB4-0C51DD3DDBFB', '0361PT'],
    ['90F4CEA5-D597-4CAE-AA91-4DC54A3AA6AE', '0364'],
    ['E2B5E352-C716-4A64-A72D-0238A68749CD', '0388'],
    ['7733AD8E-FAAE-4C16-9FB0-1988EA3B4B21', '0388MA'],
    ['E078A9ED-5EB0-4411-ACCA-C2843AE7A6C7', '0391'],
    ['15F57F00-54DF-44D6-95AA-7AA8FB0DB667', '0391MA'],
    ['5BD5E609-6F6F-4086-94D8-DBB427320B9E', '0393JS'],
    ['680A6679-B8E3-4C5C-ADB8-B44D5528DC52', '0393PT'],
    ['B2F1D048-6266-4D6F-854A-09384A32DEB7', '0396PT'],
    ['45FC9D36-8FB8-47F9-9FC5-C01D0BD85040', '0408'],
    ['5B1A949F-8D77-4A0B-8827-25AD352B2B5D', '0408MASS'],
    ['4AE0990A-08EB-4734-A626-7373006F96F1', '0409PT'],
    ['66CDB48A-426B-4B98-9B90-988B2B0AC01A', '0415MA'],
    ['4315BABF-C1E2-46E0-B6AC-9B22884E53FA', '0421MA'],
    ['6905E8F0-78BE-4FC1-9DC8-7F87DC730E64', '0429MA'],
    ['7DC68F01-1F79-407B-99A0-1EB99813E9B0', '0440'],
    ['CBCA3980-C817-49D2-B6ED-0D8311001B94', '0448PT'],
    ['27F91131-E30C-4927-A2F5-81C835BABD10', '0475'],
    ['B22A3791-C2A0-4409-BA57-B7D4824D0D6F', '0497PT'],
    ['D02585A8-9DC8-4AC4-BABE-1C6947599C34', '0500MAEP'],
    ['C81A13B6-C9A0-4E12-B769-9EB9A1BD59A8', '0502'],
    ['054A8649-781E-446B-8B68-EAF5CC4D69F0', '0512'],
    ['AE09675B-EAE9-4BA6-B911-0651B3D7CE09', '0513PT'],
    ['41A48C08-D2E6-4A3D-83E7-2004882A6911', '0518MA'],
    ['1AE64A4F-A55B-4677-98E7-7FAE00048BC0', '0540'],
    ['6168BD23-4788-4CC0-98D3-AE42CB9A0772', '0549'],
    ['4496B69B-0137-4876-B7E4-1F810BF17559', '0555PT'],
    ['7DAF3D69-044B-4998-B665-1F2BFE2D582D', '0556MA'],
    ['50E02DC1-52FA-4625-AC19-AD03063210BD', '0603'],
    ['9BB3389B-0BB3-4E7A-911A-7CCE67AEFFF2', '0610PT'],
    ['51CA36BB-C730-4D4B-A7B6-2631FEF9508D', '0615MA'],
    ['DD67AB61-2603-42D0-B25B-6FF3C2571E48', '0615PT'],
    ['5F024AE9-CB8F-4AD1-9C23-43D96971A6A3', '0615R'],
    ['C87D09DD-2138-4998-BCCE-572575143F36', '0618'],
    ['F6AF7DBD-C11F-4387-A894-0786DDABAB72', '0618MA'],
    ['6BCD71BF-B717-4E4B-9568-4FC68BAC35CB', '0620MA'],
    ['76F6FF8C-FFF9-48E1-952F-82A7D7D56C66', '0621MA'],
    ['273CD182-78D8-44AD-99F9-AB423F17EF90', '0622'],
    ['241833B9-A44F-49E6-94F1-5E0143936125', '0624JS'],
    ['152A7AA8-B641-47DA-BC68-71B17500D933', '0633PT'],
    ['17A2A0E4-19B1-4BD0-AA09-FF7C3AA72AD8', '0650MA'],
    ['15EDE3D6-4C6A-4D7A-ACD1-659AA5D976F6', '0655PT'],
    ['D6AEC31C-E590-4B46-B462-B0AE76CD1DB6', '1001'],
    ['6BF0E82D-CD26-4385-BD55-403227F66FB9', '1015'],
    ['E5F8C373-12FC-4323-88D3-5ECE0588A45A', '1023R'],
    ['9498F5FD-9563-4928-941B-A1E6F2AEC994', '1025'],
    ['4A540BCD-9EF9-450E-BFE2-8F621BC45977', '1025R'],
    ['FAE48837-7558-4815-AA14-B76B349D1779', '1028A'],
    ['EA5FA02D-3114-44FB-8CEA-0C6CC4A1D3E4', '1030B'],
    ['F7CD0F43-40FE-4E1D-AE7C-3D59D2D58B0F', '1030PT'],
    ['B16A4237-990D-4B12-A408-6F8B26084ABE', '1032CMA'],
    ['F285A25B-E64D-447F-95F8-67C8BBB13B14', '1032D'],
    ['0B4DE4C3-5059-47BE-8C6A-AC1998C9EDB9', '1033PT'],
    ['4FEEB859-6D87-4063-9E1F-E7B199C3F556', '1036PT'],
    ['68DAE69A-F6B9-48C7-BA42-A448F41714AB', '1039PT'],
    ['0DA36A93-4444-4837-9670-4AA5AA85B588', '1040MA'],
    ['CF957E4D-A453-4AB7-85B1-D58D2EC44741', '1046MA'],
    ['561D36C1-55D7-4B8F-8E84-6394F63F682E', '1056MA'],
    ['92292325-AC51-40F9-9078-8242F4EA9629', '1056PT'],
    ['A1AC3A67-A55A-44EB-A482-F200A83B0AC8', '1059'],
    ['5CCC941D-38F9-4538-AE38-CCB511A5D04B', '1062'],
    ['9A2A1444-8D74-46E7-AE12-3001FDE75426', '1064PT'],
    ['CF0F0546-50D4-4166-8907-25C957288F97', '1065PT'],
    ['0F7E95A8-7786-4AE3-BBF4-BC80E7286D97', '1080'],
    ['5E67F57E-B58F-4A3F-98D1-041B467B173C', '1081'],
    ['3D54C8A1-4D9F-4E3F-B489-84E3A435FA3B', '1082'],
    ['72C49062-8C4D-4112-9B98-D2903B389051', '0012'],
    ['CD3CCAE7-C1A6-475B-8926-BADEBBF18165', '0015'],
    ['43158AEA-0963-4B0E-BE3F-028B27D6BD9D', '0035'],
    ['1EC1C9BE-2E85-4886-9C61-0FC7C7719390', '0035SL'],
    ['274F7944-0C6E-4C5B-B025-B006204855C3', '0036'],
    ['EB81283D-0A77-4886-80A0-E11C4A76BA3B', '0204'],
    ['8EF37049-062D-4E9A-A6FE-044899B1BA20', 'A512'],
    ['3743C3A8-D220-47D8-9A01-39724EC79490', 'A513'],
    ['F2289B69-7726-43FE-9355-85C905AECE38', 'A513PT'],
    ['D221AD2C-F496-420C-A32B-B76B2A19F277', 'A51AMA'],
    ['00961494-0BE5-42C6-8B06-385C922B9E89', 'A51D'],
    ['114602AB-F586-4F61-93B8-2895FD83240C', 'A51MMASS'],
    ['162B8AC3-20E7-442A-A8E3-F0EA04494B48', 'A522MASS'],
    ['82C20B40-7A65-443E-81F1-C2D8DEBEFA8F', 'A523'],
    ['F24C2A8C-D68E-426E-96AD-576855DAA4F9', 'A524'],
    ['D6544FDC-BA3C-4B74-AFEB-8E631E74A9FB', 'Av Mil Sc Te'],
    ['EB09BE8A-73E7-4784-B9B5-40F0DFFF5257', 'E032'],
    ['1F28AEEC-DA7B-4581-9752-AB3D9AD6FDD2', 'E032PT'],
    ['198B5A06-69C2-446D-A2B4-22E8CA8B032D', 'E038'],
    ['E349565A-C11A-41E7-9098-5525D09B3EE7', 'E049PT'],
    ['935A22D7-0E79-4FD1-9DEE-4CA6246189B1', 'E091PT'],
    ['F07F9A5E-4A98-4A6E-84C5-9C43A896A8DE', 'E165MA'],
    ['A0E553EB-6720-43FA-B8B3-89F3587BD638', 'E167'],
    ['82828D2E-70B2-416C-9BC5-28EAD2D0A65B', 'E301MA'],
    ['44B3A689-D3F6-44DA-842F-5D17AD5BEF05', 'E305PT'],
    ['F169A4EC-CC76-4BAF-959E-CF60E45A64E1', 'NN50MA'],
    ['745A31FD-98EE-459F-8887-46EEB2099769', 'NN55'],
    ['E5260D48-07B7-47AB-88D7-6A21D1CD122F', 'NN62'],
    ['43E5EE76-9F69-49D4-88EE-95DCAA49868A', 'NN63'],
    ['4BB81447-A6C0-4C51-A2B0-3AE89F96CB29', 'NN64'],
    ['F1F2F750-2C68-4F7A-A661-28FEE0512907', 'NN90MA'],
    ['CADF7937-71FF-4EAD-98CA-72777E272F64', 'NN91MA'],
    ['46035FD5-A967-41FF-BBA1-65F0C5B7021D', 'NN92MA'],
    ['96669CF9-DC94-4FA8-9844-7B76C6C43DD7', 'Principal'],
    ['74D6EE1F-9C68-475D-9B15-B538EEF56340', 'S005PT'],
    ['16AC461B-DC09-4877-93ED-20536709C624', 'S016'],
    ['19854516-38F4-411E-9970-0F1DD50BF67B', 'S016MA'],
    ['B2930D28-1953-48AB-B298-4D44B90E92C7', 'S023PT'],
    ['267F8B72-9C65-4E34-A300-2198AC34712F', 'S024PT'],
    ['25C42647-F69D-4911-A1AE-E11E345C8955', 'S028'],
    ['98BE719D-8E09-4BF9-8A9E-D9FCC8DFA917', 'S043'],
    ['4BBC378A-35A7-4B8C-84D7-8FC262EA31C8', 'S045'],
    ['0BB686F3-50C5-411C-BCE7-390B095A6604', 'S046PT'],
    ['9C9280B0-07E8-407C-955E-7A7BC5812822', 'S048PT'],
    ['3D5F5CB4-5814-415E-9159-2DE02392B49E', 'S057'],
    ['ED4AE201-575D-4490-9CD1-6949B3F40C95', 'S062PT'],
    ['8446A76A-8FC2-44AF-A2DD-8BCDE8626A78', 'S113PT'],
    ['88A9EDB5-0126-43A3-AAF0-8F518B73482B', 'S120PT'],
    ['616E7157-8EFD-4E11-BDED-3E3DD3FFE10C', 'S123MA'],
    ['28664B65-97A6-4AC7-9068-8E664EC0A1F9', 'S127PT'],
    ['973F28C5-D70D-433E-B555-F4221D826C65', 'S128PT'],
    ['9E0F2173-F57F-47D5-84EE-B1012DA14E02', 'S129PT'],
    ['8CADA5EE-BEB7-4055-8C85-1A0FC39BF33A', 'S152F'],
    ['DCFD2E62-FB1A-4433-BC6A-6B541DEB351E', 'S161G'],
    ['F3961060-5DFD-4DF6-ABF2-C9176973E64C', 'S162'],
    ['C1B6456F-A293-4970-82B1-28A1AB62ABE1', 'S162G'],
    ['64D2EAF2-E098-4E7D-B6FB-3C8BAFFC426F', 'S163F'],
    ['3E5F8A4F-A6E1-4AB0-9046-979E7D0F82DD', 'S262MA'],
    ['BC0F1772-E958-45A9-BC23-3D9D2DC04819', 'S263'],
    ['3A572446-CC57-44C3-ABAB-037F2C5B0F80', 'S300BPT'],
    ['CE2A36CC-60A8-4CA1-A42C-31A14C0DE0D8', 'S300DPT'],
    ['25AB754B-5B48-4D2D-86D9-F45E7F2E7406', 'S301B'],
    ['5A03C374-E6E4-4A02-B5CD-70C61FF78525', 'S301C'],
    ['A8542B6F-B6EF-488E-A0D8-130A68627AF7', 'S310'],
    ['714A296E-B5BA-4D83-8F44-0A022F6A8868', 'S647PT'],
    ['A0E2587D-551F-4485-A91E-27DE141B198B', 'S656A'],
    ['13998151-1279-4D44-891B-996C284FF833', 'S691PT'],
    ['A8AF9B60-FEE1-417C-BD6A-48FA35EC2E58', 'S702'],
    ['B193990E-DA34-4989-94A2-57D2B25AAADC', 'S713'],
    ['AE874F6C-F34E-4340-94C4-F149EC5B3D38', 'S730'],
    ['75EB6783-0C52-4823-95C2-C176A5C1ED7F', 'S740PT'],
    ['3E08732D-F396-4A48-BE57-9B9EFB914DD7', 'S760'],
    ['CF0F5B44-D9C1-4AEE-883C-B17E85FA431F', 'S762'],
    ['568338D5-3416-42FF-8BBE-64D271C4ED28', 'S801MA'],
    ['942F8411-D4F0-46D4-AE14-45120849E91E', 'S831PT'],
    ['E4574456-5833-4B68-B319-2F74FA963A75', 'S841PT'],
    ['B2988357-89A0-4E79-9769-FDF7013ACD77', 'S861PT'],
    ['3E1CBB03-5A96-479A-B712-BEE09034A623', 'S942PT'],
    ['B9FDFBE3-4FB7-4696-B712-4C312921E46D', 'S951PT'],
    ['4E154BFD-AE71-4D94-98E7-AB572639B8BD', 'S990'],
    ['CAFCBD0D-A66B-4E77-B25F-B7407BBC5AF6', 'S993'],
    ['B72E763A-5314-4C77-8F46-792D49234FDA', 'S997PT'],
    ['FAD450FD-1B64-4EE1-9CB0-4EA6B5D7E50D', '0227'],
    ['6B48D86B-D78A-4282-A123-C6C1CF12988B', '0319MA'],
    ['CAA0CD23-D991-49E7-BCB1-001E816B1342', '0321'],
    ['22DBEFF9-F970-42A7-A7BE-6759DB762E4A', '0330JS'],
    ['546745C1-57D7-4FBE-AE6A-3F75880AFFD6', '0331JS'],
    ['0A87646B-066F-46CC-A9E9-3E40B12DA2A7', '0331PT'],
    ['2963B6B9-F77B-4004-B187-6021FDBACB44', '0331R'],
    ['5B6C720F-A29D-4372-B298-FFB4AB83DA1E', '0334'],
    ['4E008B41-26E2-4D87-9877-7C9EE48B1F4F', '0334R'],
    ['6B670683-5BFD-49B5-BA7D-F3A92F573528', '0340MA'],
    ['A8889B4E-E935-42B4-A809-139F68600A73', '0342'],
    ['6DD9D079-652C-490F-92E3-A7DDB43B3275', '0342MASS'],
    ['F91064C9-39E1-45EB-B407-90DD60FE0D2F', '0343MASS'],
    ['C3928DB4-4AAC-4BAE-B107-14246DFC397F', '0344'],
    ['94997B66-6553-42BB-A426-2017DD76CCD0', '0348'],
    ['FF094412-7375-4F28-9633-4EB093CF1819', '0355R'],
    ['83A2D5AC-036D-4506-850F-A49DD6DCFCED', '0356'],
    ['CD013A7D-C465-4D5E-BE0D-834B1387ACB8', '0356MA'],
    ['E51ABD19-6A2E-4915-B29C-BF05FF896AB5', '0363PT'],
    ['09E5BCB3-5243-4259-BDB9-FAB1E77C67D3', '0364PT'],
    ['B483E452-CEB8-4B94-86FC-47EE4A299659', '0393'],
    ['DC217F3A-FA19-4C21-9231-26DB3D08001F', '0395JS'],
    ['EFC480E4-32B1-48A0-8B44-2170DBCCBD15', '0395PT'],
    ['F418728C-86DD-423A-90C1-1B05193A6C69', '0396MA'],
    ['FE8C765F-0074-43D8-BE75-83EF6838F8F2', '0408PT'],
    ['66438BAF-5661-4829-99BA-38A12E3CF83D', '0411'],
    ['AAF3AC38-08D8-42CA-87BE-BD74E0E08EDE', '0416PT'],
    ['ECF39585-34A3-4C41-A1E6-219E4A20CBEC', '0418PT'],
    ['6CC3F428-095F-48AC-B830-D18D902396E4', '0433PT'],
    ['4A7B2DBD-2525-4909-8B91-53B2B7E06684', '0443'],
    ['0C11AD9A-4DCC-46FF-8AED-C89979648DB2', '0455'],
    ['1554AFE7-F290-48BD-A5F7-6F0181DB90BB', '0455MA'],
    ['05D242AB-F4AD-4278-AE5B-C989C113D138', '0456'],
    ['08A5001F-A034-4E2C-B883-3BCFB0055243', '0456MA'],
    ['B6E36FDC-19C7-4F3F-9636-AF79482D000C', '0457PT'],
    ['581F1EB0-924B-4B15-92B3-F44DD24E7D8F', '0499PT'],
    ['10C979FC-3121-4166-8C92-D91C5C144D91', '0506R'],
    ['7B9B8995-866B-4A1F-90ED-1218946F1C5A', '0508'],
    ['A45F06D8-AE80-418C-87AA-A031F75761C9', '0508MASS'],
    ['468D5E55-1D82-42B6-9715-DB0E089E739C', '0509PT'],
    ['289B468D-8351-498C-BB10-1F2501A67A14', '0510'],
    ['2380E56A-250D-4B52-B1C4-0D12C78EE5AB', '0512MASS'],
    ['7D1D4963-DB7B-487E-98E7-83C9A8C3BC64', '0513'],
    ['C8B6237B-AE5C-4622-8DFA-A8BB5083D7B0', '0515'],
    ['D968C1FB-FDFA-4711-899F-83F461851179', '0519MA'],
    ['DF93D182-E068-4577-B032-F1847997C5E9', '0519PT'],
    ['2E4CE68B-D9CE-4330-873D-C45C7F069FFF', '0541'],
    ['77584F00-DA12-4749-BB98-F7926F266864', '0548'],
    ['D7965ACF-E1D1-4610-819A-6DF6C4085D8D', '0558PT'],
    ['7684660C-D587-4EBA-8795-19CC5157EC2F', '0559'],
    ['68C20457-5419-4097-A0A7-6141E611205C', '0559MA'],
    ['B697BE4F-1E81-4F41-BD77-85ABE63BBC2E', '0599'],
    ['1BE71B0A-58C9-49B8-B70B-CAB2581F25D4', '0603MA'],
    ['922A17C6-BDB5-455F-A216-054537FF7DAA', '0604MA'],
    ['53ACEAF0-974C-444F-ABF2-22100F094CC1', '0604PT'],
    ['994F0068-6685-4658-B783-7DAA506155CA', '0605MA'],
    ['7056CE07-9304-4F0A-A56A-1B6A3C416F80', '0612MASS'],
    ['FD59C687-BB84-4211-8461-3647813076F2', '0613PT'],
    ['181E4BD0-7247-4C34-8AC3-784F599BEFC1', '0616'],
    ['2BCA9D2E-1F23-44EC-B8B7-B13783C6EF31', '0616MASS'],
    ['A1D9108A-3385-4A9E-AFEF-392F8D7FD099', '0621'],
    ['2A2064C2-FA98-4F51-AB3D-4DCE759F8352', '0624PT'],
    ['25B1705E-23D2-47B5-993F-B21790F10F5E', '0626MA'],
    ['35C88EC5-4888-42D5-A1A3-618137F4DB83', '0630MA'],
    ['96739C6C-1721-41C7-B33B-FFBA18ECC581', '0630MASS'],
    ['E1FB6530-2415-4A25-873C-66409EB8608E', '0632MASS'],
    ['D9BCA91F-AC16-4AA5-9315-C4CEE931D9C4', '0633MA'],
    ['0EAC826C-ABB1-4A8C-9DF2-5CF5069CAC4D', '0670MA'],
    ['687F7D78-E08D-4FC7-A07E-CC8E5C94A9D4', '0680'],
    ['E8489071-5876-4B98-8EFE-4E96E2A3AFE9', '0700MA'],
    ['5CCAEB68-F287-4E88-B86A-2BD7D4C375A6', '1025MA'],
    ['1F0AE8BC-740A-4655-A89B-2E2EE6DA3E48', '1028B'],
    ['534C6D89-5C4C-4A00-8B90-E1D78B97B9A9', '1028BMA'],
    ['5F7F6782-7B31-46F7-8723-8150411ED751', '1028BR'],
    ['E5EF7ED5-854E-41A4-8578-32741207AB3C', '1030C'],
    ['3A220DE6-3C27-4E3E-BB3E-C9AD811A26CE', '1030MA'],
    ['808B5F59-1857-4280-B042-EBED52579960', '1032AMASS'],
    ['716978A2-D7EC-4DD2-965A-C4D5CFF44B5B', '1032AR'],
    ['F7107826-3053-443A-8138-E3BE55D1F9F1', '1032B'],
    ['394BF5A8-E2C3-45D2-BEBF-C37A05C71665', '1032BMA'],
    ['90028B1D-9FEA-45B1-9125-FA80C45EB208', '1033MA'],
    ['540F8DB2-72EA-4EFF-A863-4491C9695C7C', '1034MA'],
    ['FF582BC3-7F07-43FB-85BF-0594B19780ED', '1036MA'],
    ['A521EB1F-87E9-47FB-A2DE-7EBAA8A1965B', '1037'],
    ['BEF0C67A-4959-45DE-856E-7D82D13F4319', '1045MA'],
    ['0E193889-6F78-4D1E-95AA-6B13AB6C44A2', '1045PT'],
    ['3FCA7993-47A4-4C1C-9B79-9CA27D8879F3', '0010PT'],
    ['88B2A901-8198-4136-9AB3-80C2B9CEC61C', '0020PT'],
    ['041745EA-A1B7-4160-B070-F5A66AF2B719', '0032'],
    ['D96CB75B-5C47-458E-B4E7-9B67F52058AE', '0035PT'],
    ['F451FB27-8417-4A6A-BD5E-D3319223C4AC', '0036MA'],
    ['BE403B17-DC0E-4118-9D1B-C1ED32E5B246', '0041A'],
    ['B14F5036-9211-455D-8595-373E77978AF6', '0200PT'],
    ['F3188839-131D-4198-89DB-D742434CF8AC', '0206'],
    ['36223587-80AF-4A0A-A992-E9FA3C15613B', 'A511MA'],
    ['65897CA7-EE80-45E2-83D4-6239B3F70276', 'A514PT'],
    ['C636504F-C045-44FD-B974-A991105B0DFA', 'A51APT'],
    ['3365410F-60E1-4A31-BEB0-E71EF8E8E3F8', 'A51B'],
    ['53EDC45F-226D-4015-BB68-613A58BA7942', 'A51DMA'],
    ['C881A83F-9B96-4B38-A8C4-D2D47FB9E45E', 'A51E'],
    ['911C334F-E1FB-4BF6-9815-6D06A0B3EEB8', 'A51EMASS'],
    ['3E0FD393-813C-4E21-9E93-ED5BB9CAC660', 'A51G'],
    ['0A184CC6-8FD2-435D-B592-E30931AD27B0', 'A522'],
    ['707DBE02-30FC-4BAC-917C-CC0F67480EB2', 'A523MASS'],
    ['D22EC61B-9686-4FE5-A606-6DD44AC4239D', 'A55APT'],
    ['5DB05A24-51B4-4130-8739-B91E92FCC3D7', 'B778'],
    ['0D40DD43-CA8D-4333-8FAF-2B9C17113A29', 'Z100'],
    ['9AAFC09C-A6CD-486C-B416-4394EF1D8EAB', 'E005'],
    ['3754E808-70EF-4C2E-916D-817FF7FB072A', 'E005MA'],
    ['9CD0B62B-7941-44CF-B4B9-6E6A8B33524D', 'E005PT'],
    ['C571BBA1-5DD7-46B0-BC12-60901F92461B', 'E049MASS'],
    ['94038DAE-C876-40FC-93FA-B1FD2783819C', 'E058'],
    ['5605093A-3EB7-4430-908F-10E027782763', 'E058PT'],
    ['2F762FC2-A94A-4402-B9C1-E17363C20CD7', 'E092'],
    ['9B545E05-3EA3-4887-A77E-6E367A9946E8', 'E092PT'],
    ['E29FD204-1DC7-4BFD-98B6-C9AE3DE82D17', 'E093'],
    ['AA994328-0839-4C4B-BDFD-53A47D1A8DCE', 'E166PT'],
    ['79FC7E4E-55CD-46AA-9E7B-232C3600C63B', 'E300'],
    ['A036D8C9-BE51-4689-BB07-270B6B7BA9CC', 'E305'],
    ['03D4F1BF-98A6-4063-9EED-FE6BD3E3C830', 'NN40'],
    ['2E686ADD-B4FA-42CF-B230-E2F647C6725E', 'NN57'],
    ['11DE2AF9-2856-4DE5-A8D3-1A77411F6ABD', 'NN61MA'],
    ['040DC7F3-8900-4008-9561-1BB084864EB3', 'NN65'],
    ['30BF8214-2BFA-4430-82A6-80EAE565A377', 'NN66MA'],
    ['7FD6182D-815B-42CC-871E-8647B8347957', 'NN93MA'],
    ['6AF7AF6C-E5DD-498D-9E35-7F251460FCDD', '0223PT'],
    ['985DF869-D05B-4A81-9A0F-E39522D88772', '0225'],
    ['FC09DFD3-FB47-486E-85B0-8CE6445C5422', '0309'],
    ['74402822-7CEA-497F-B098-43DA8149EA59', '0310JS'],
    ['02AC9D82-9455-4DF3-B7F8-F020FC6547FB', '0322MASS'],
    ['DF7CC2E9-A2C8-47AC-85C9-980FF998408C', '0332JS'],
    ['428E095C-55E0-41D5-B46B-D8CA025D9A39', '0332MA'],
    ['ABC66403-82E2-46D6-B09F-2BA3D9542A06', '0332PT'],
    ['070ADDDE-A334-4DF8-9EDB-501D99672AD7', '0333PT'],
    ['589DF4BF-4BB1-4943-A8D7-8CFF93D9BF75', '0334PT'],
    ['88F4730D-DB84-4478-8BF8-36E271D49EB7', '0340MASS'],
    ['62AD6658-4B5F-4A1E-AB2B-29873A1D00A6', '0344MA'],
    ['274B2D3D-29FF-45D8-B05D-0BF490D301EC', '0345'],
    ['679CAD0C-C15A-4374-8FA9-0B6EC2D36EE6', '0345MASS'],
    ['1A915092-3232-40A7-AE64-998DC47896B0', '0349PT'],
    ['3292BCFC-BC55-4F22-85C0-9E37B7E61A12', '0370PT'],
    ['EF166A63-FA4C-4907-B481-27A576A80448', '0392JS'],
    ['BBAE72D6-D376-4570-9258-6B3961919F84', '0392MA'],
    ['E066D8BE-0CC5-4695-8B8F-6C059AE8E006', '0393MASS'],
    ['CDE94D2E-3D2D-443B-8705-08B3266B646A', '0394MA'],
    ['84E0D478-A74A-43B1-B634-B38C108B09E9', '0399PT'],
    ['09E02A61-A669-4ED1-B8E5-EFBF5D544EE5', '0406'],
    ['10511601-A54C-4B4D-A863-993572DD1588', '0406MASS'],
    ['7C1BDF78-EDE5-4BCC-9934-7FA48D1E6F39', '0407MA'],
    ['CA9BEE77-8AC9-4307-926E-9B18A1E56E38', '0409'],
    ['63AE38EE-D0B1-46B3-802A-E35E92CE91F7', '0410'],
    ['DBF69E95-D3EC-4176-9052-72E28D3AA456', '0412'],
    ['612295D9-48D4-42D8-8B9A-9A05AF3BEDD3', '0413R'],
    ['35D949A8-7C56-4A58-8B0E-37DDBD150976', '0418'],
    ['FE87774F-8AB3-4EF5-B418-9B68497176BB', '0435'],
    ['CE060E40-7ACB-4DAC-9C11-52B32805F7D8', '0435PT'],
    ['BE83154E-7E1C-4465-B39D-9D2EAB8FA603', '0440MA'],
    ['DF482CDF-B2ED-4CFC-8589-13FE5BA6D7A7', '0443PT'],
    ['0BF35E4D-1799-4800-BFCF-CB6E46E9B0BA', '0448'],
    ['920F0215-43E7-49CC-9338-022E0BBE48FD', '0450MA'],
    ['7789E591-4B58-41D8-9C97-0AA71F485658', '0450PT'],
    ['537B8EB2-E40D-4340-A52A-AA4B23FDBD48', '0458PT'],
    ['04DF3362-85AE-44E1-ACD1-D99FFF3DEBA1', '0480'],
    ['FAEBF05B-561B-494F-9CCD-442F0AB309BC', '0485PT'],
    ['073C47C9-E1C4-4509-833B-54D392C08DEF', '0506PT'],
    ['66CFCEA2-F3AA-47E9-B0C5-DA4CC7EB197C', '0507MA'],
    ['627E2EFE-E3D5-4BD9-AE77-F52E4C064D93', '0516'],
    ['90E49961-91C1-4D91-964B-7102C39981C8', '0555MA'],
    ['734892AF-0DEE-4433-AE84-AA28636DB4C2', '0557PT'],
    ['583CCA32-FBF5-4AF1-A3BC-1B0E0BAD75CF', '0605'],
    ['5796C47F-F2D7-4CFF-8323-F2894DF3D891', '0612'],
    ['8D5B7229-2402-4B53-A148-CBBFD211A154', '0612MA'],
    ['4A21224D-F707-4E21-8838-6346275A18FC', '0613MA'],
    ['93D0DA59-2CDF-4E78-9D2B-3442F34D5EBA', '0615MASS'],
    ['854E25C6-5028-4336-A691-774B5798A249', '0617MA'],
    ['EC933ADB-8A87-4576-8D93-D2A6BEB325C3', '0620R'],
    ['358BCFFB-E7D5-4DFC-9E72-32FB959E58AD', '0621PT'],
    ['5F8A31DC-579B-4AE7-813E-0832D29CFEBA', '0625MA'],
    ['F37E9861-E48F-4355-BB83-BBD7F20C7867', '0627MASS'],
    ['639AFC24-24EF-4CD7-9EA4-531D78A265C4', '0670PT'],
    ['8FC8AF0E-E9EC-4AEB-8E9F-9A79D3DB8265', '0675'],
    ['63BFA6A4-E66E-491C-B623-A953E0A1DE83', '0685MA'],
    ['EE2DD61A-E440-472C-ABDE-E1D37F907222', '0685PT'],
    ['8B8CBF40-7835-4591-8989-63CA7B078F60', '0690'],
    ['5DBE1964-D6A6-463F-8FED-4BF44E446F61', '0702MA'],
    ['415E9832-6F10-4765-BAF5-F406D15EEB28', '1001PT'],
    ['E307DDD8-7DB7-4683-B217-92B89DF7021F', '1020'],
    ['ABF4E248-7DBE-418E-ADA7-E8CD2004EF12', '1021'],
    ['152B4F7F-B3B7-4B94-9D14-C8A9EE20A015', '1022PT'],
    ['00937A4F-E3FB-479C-A55B-7C6B28682C28', '1023MA'],
    ['2BCE1F56-7EB3-4613-8F17-D2B4FE487CBC', '1027MA'],
    ['3FFBBDB9-C7D4-4BA0-B0D8-C4F2E640205B', '1032BPT'],
    ['CC856841-7306-4B9F-B2C4-1571A3C32F1F', '1032DPT'],
    ['7FA27611-ED3E-45EA-B0FB-3BF13DDAEEDA', '1033'],
    ['530A7D01-D7BB-453E-A456-5EBCEEB3DB8E', '1034'],
    ['B389D177-4D82-449D-A636-511269476BE8', '1034PT'],
    ['D0707D2F-8D2A-438B-97B9-5457B6F405C2', '1045AMA'],
    ['F6232962-2755-4868-8B9A-5C4E60C85C6F', '1046PT'],
    ['036A93A7-0EBF-4B8F-91FA-8D667F767271', '1060'],
    ['C0C25981-8BD0-4E74-AAFB-D4DDC42F5928', '1062MA'],
    ['F4412FFA-A85C-4505-AB09-18BFE105BEC2', '1062PT'],
    ['26A498B0-4005-4A96-B27A-44F2FCA26557', '1063MA'],
    ['A7539A46-8612-425A-9C38-7E65032D7B80', '1081PT'],
    ['C4DBD2E3-5952-40D5-BFA3-8D501E7F75EA', '1083MA'],
    ['4AEF86DE-621D-4716-9432-A95A8A557304', '1090PT'],
    ['CF7B6EA1-FB4C-4E84-B6F5-440AF3D74704', 'Para - ESE'],
    ['7E1226CF-3370-44A7-8125-850D1C1CE3E5', 'S012'],
    ['3DF4E617-69E5-43FD-B6AA-027C6EE8F1A5', 'S021'],
    ['021F4AFC-B493-472A-921C-EF5918BF5F39', 'S048'],
    ['92D5138A-FF12-4C29-B515-68DF9A528871', 'S075'],
    ['68C29A11-CAB0-4D3A-A271-F5BE69F01DED', 'S076'],
    ['13254453-BAB9-4B47-ABBB-826962173FEA', 'S082MA'],
    ['967D36AB-2BC8-4B51-99FE-D7A37C667299', 'S090'],
    ['E19DE5CB-715F-49D0-A542-C33A1C366A51', 'S112MA'],
    ['81386BE2-2842-42C5-9F4A-B9BD74603DED', 'S124'],
    ['D4461411-5AB1-4F43-AA7D-BA9E06EFE690', 'S126PT'],
    ['454A7F0E-0254-45D0-85AE-4533EB9F25B6', 'S161MA'],
    ['5693E3D0-00DA-4053-9166-161FF68F415D', 'S161PT'],
    ['AB144E98-7BEA-4B9B-9FD0-FCED74B9BF5B', 'S163G'],
    ['4D3AB7CE-1C51-486B-83CC-0552DC2C1407', 'S164H'],
    ['04BF48C6-49CF-445F-8A4A-FFAF46B2F329', 'S214'],
    ['239EF15F-4EB1-481E-8A09-1AA13A7EDAB3', 'S214MA'],
    ['31FAE970-EA04-47F6-A2DE-BF22EF1EE8DB', 'S222PT'],
    ['A16187ED-DB04-4B96-B9D6-40A985EDFA31', 'S232MA'],
    ['A546B20D-8E35-45FF-AF5F-A96CF6E7305B', 'S241PT'],
    ['D2E77BEC-8BE1-43B1-ACDE-1E9405459819', 'S261PT'],
    ['3F3853CC-D571-414F-AD2E-38727084E3E9', 'S262PT'],
    ['55DF60B6-65D0-4D60-8094-CEAF77FCFA5D', 'S300A'],
    ['0F742E63-A310-4CA4-96F7-EC999EF520CC', 'S300B'],
    ['50BF612F-D0D8-49CB-B3CA-6310C05D6D0D', 'S300DMASS'],
    ['1E527676-C240-41A8-82BA-8B2AEDF66D70', 'S301BPT'],
    ['0B3C893F-2330-49AF-BD62-535763A32B07', 'S301D'],
    ['DDEF4CAA-1D87-4F3F-8CCC-FD578244DD8E', 'S301DPT'],
    ['37902A27-35A6-4D20-BB7A-ABC1308D04C2', 'S311MA'],
    ['5810A2B9-C01D-40CC-9CCE-D1B318404A58', 'S312'],
    ['0651C715-6C74-435B-8798-62F14840AA37', 'S423MA'],
    ['C702FB77-49A9-4331-8043-C8FD4C71681E', 'S655C'],
    ['CDC0BDA2-8620-4E62-98C4-7CBAB4DA94FE', 'S655PT'],
    ['1EBCB7A7-80E3-4055-ABF8-2988ED0A8556', 'S680'],
    ['D085023F-AF46-49A3-8080-C839F5F8D9C7', 'S700PT'],
    ['CB499C70-A737-446D-9558-0367FE2EE710', 'S710'],
    ['193610FC-3529-4C68-A58E-06972B1600DB', 'S711PT'],
    ['0C2D9042-447D-40D8-87B0-6BA9A030CE68', 'S731PT'],
    ['32876D7A-E78B-4501-ABF6-A17465C9BCF3', 'S732PT'],
    ['418DC1F5-611A-4F12-A4C2-62E36C6CA731', 'S761'],
    ['A810ADC3-4F7C-428F-8C45-EB3F8E0ADA3D', 'S761PT'],
    ['65769C14-89E7-4454-9BF6-5A0EA6C8B246', 'S762PT'],
    ['E0E5838F-F87C-4AAC-9EED-3211C018E23A', 'S805'],
    ['0C92EA28-09B0-405B-8624-FED463A38A72', 'S812PT'],
    ['14E2B164-2C22-4FE1-94A9-80F98453AAC3', 'S814PT'],
    ['BE3D30D9-6572-4479-86E4-92BD554C824B', 'S831'],
    ['5762BB61-CB7A-4E3A-A749-B8E5B0D9126F', 'S852'],
    ['0519C18A-D0BD-4345-86B1-B2026A6199DE', 'S910'],
    ['9AE01B0B-B642-4566-8B7C-FF670D63EC00', '0015PT'],
    ['56E64029-8780-4B6C-9B85-8997BB688FB7', '0025'],
    ['BB9FAB1E-19E1-4498-B6E7-C17A8E29F473', '0030PT'],
    ['16C2C144-5E73-4351-85E1-85A7A7408C51', '0200'],
    ['10A7105A-D8B8-42CA-B253-2C09CB873DD3', 'A511'],
    ['4142492D-6839-4640-80B3-DEAE7DE3A879', 'A516PT'],
    ['8CA411E8-4B01-4B59-A9A2-A04583C96168', 'A51BMASS'],
    ['524738FA-B0B9-4C0D-B6DE-32E28B8EDEFD', 'A51CMA'],
    ['59E523BF-B50B-4F96-A5DF-FF97BFC5237C', 'A51CPT'],
    ['EE5A73CE-E4BA-4E64-8B4D-E4B933861F23', 'A51SMA'],
    ['51DD8D15-545A-46A3-A6CB-DBE66D14CB1B', 'A525MA'],
    ['97DF0C06-8653-4FD8-8078-CDC44359D52A', 'A526PT'],
    ['DB0E385D-89E2-4C67-999D-E7A95D3F25FD', 'A527'],
    ['7DE4AEE5-1EDD-4014-B973-2FF5E313BDBD', 'A550MA'],
    ['D1C1C349-EEC0-4334-AACE-7033A9C4D40A', 'B777'],
    ['FA994697-5CD7-4632-98BD-85C53E22FAB2', 'E001'],
    ['219797E2-7CC1-4B96-8A3C-EDAC61A6FC4F', 'E029PT'],
    ['72CC2F05-292B-435E-9928-988E8E0F2301', 'E033MA'],
    ['8054906F-C88C-45F7-BC15-358400D738D2', 'E033PT'],
    ['617F9CF5-E0CC-4B23-9D2A-1AFE0CD4E398', 'E090'],
    ['7362D9AF-4317-4EA2-825C-082AB2E85CAC', 'E165'],
    ['9F5BC1E7-0EA8-4C02-A1A2-6B3F635D3FC2', 'E214MA'],
    ['0188E13A-E337-462F-94E7-7A3A21D2551F', 'E232'],
    ['1D8EDA93-0951-4BF2-A13F-E9C975176231', 'E240PT'],
    ['118E1654-AFBD-4E20-BDCF-808D5E3EF4DB', 'E645'],
    ['E3776658-293E-4868-9064-634D81E466BB', 'EDGE Teacher'],
    ['643BC093-58F8-491C-8087-94D08B8DE917', 'Elem K-5'],
    ['77662D7C-C1D4-495C-8C88-9403B67A0D98', 'NN55MA'],
    ['FB6ECC65-79FE-478B-9D54-F0A14765E1B1', 'NN76MA'],
    ['4F89EBF7-F5A7-4071-BDEA-F7FD283A3C4C', '0001'],
    ['AD1E6288-6043-4B52-AA6C-3B66A66DDCD7', 'Para'],
    ['CB8F7E60-AAC4-44A8-BCE8-73F016915AB7', 'S018PT'],
    ['69AA3758-3382-4B0E-9B77-79A45E221661', 'S028MA'],
    ['9DC6B388-8BAC-4A10-A287-7C78247FACD2', 'S030MASS'],
    ['F67100F1-4F6F-4881-B846-D2074185D720', 'S031'],
    ['CC2D053D-3FBD-4B66-98D9-4B9551EE27D8', 'S045MA'],
    ['2E8E1435-215C-4DFB-9683-981DC04CC513', 'S046'],
    ['D61EB8D6-1B8F-4B71-9B9F-5D83B24B319D', 'S048MA'],
    ['008D6608-6398-44E0-A209-9450FE46C6E7', 'S060PT'],
    ['FB5E667F-9E79-494E-B8C3-6571A67B6EB0', 'S082PT'],
    ['95D3BA98-1643-495E-8688-47F2D2597223', 'S090MA'],
    ['568D0FA9-8C50-4ED4-80C0-B82AF5E872B8', 'S112PT'],
    ['B1406ED9-61A6-45C6-B1A3-8D4572C0ADFF', 'S122MA'],
    ['BB6B8C59-122C-40AC-8DC4-5A8D87544622', 'S150'],
    ['C3F7AE92-954D-4C6E-8A09-7731C4532D0C', 'S152C'],
    ['8FC43574-2AA3-47A1-A99A-4D76C4FDE728', 'S152E'],
    ['670495F7-5D09-443D-8FB7-7FA9690D746F', 'S164MA'],
    ['3A4DA19F-A982-4FB6-977A-EBD1FF759CF7', 'S238PT'],
    ['C1870D81-ED76-43A2-8464-5B7D5090F13F', 'S239PT'],
    ['C1BD8E15-CE76-4159-9F4D-2B706A8D1882', 'S263PT'],
    ['D261E817-5ACB-4F5A-A9D1-B9E0EA3D67C1', 'S300APT'],
    ['298DCA7E-AB44-41A0-BEFE-16ADF00242D9', 'S300BMA'],
    ['F39BDB40-E368-41EE-976C-588F048DF7D7', 'S300D'],
    ['E022CED0-8E19-42EA-B1E1-556501780CD6', 'S300DMA'],
    ['4083D888-03B7-4D15-A15D-53783A83C121', 'S301A'],
    ['FF823039-3D39-446E-B19E-4A4D4A7687F3', 'S301DMA'],
    ['AED6CC00-4D8A-417B-8C48-40B6139E97E4', 'S309PT'],
    ['FA6DAC14-0D1E-4385-91EB-595B4C46A3CF', 'S310PT'],
    ['A295F789-1F52-487C-94E5-57CD235A39BD', 'S419AMA'],
    ['E55D9E34-37DF-4472-B4EC-12CA060A3C31', 'S420'],
    ['9E998E3F-8BE3-48BB-8CFF-D319008707AC', 'S420MA'],
    ['98D92CB3-D035-4326-BC16-7184DD9429E7', 'S655B'],
    ['0E4829E2-FFFC-443F-B5FC-70DFD505B0B9', 'S656B'],
    ['EE5C6BFB-FDCC-4307-AD02-5023FF38778E', 'S661PT'],
    ['387C15DB-CBA0-4014-AFAB-ABC6EA5D131E', 'S670'],
    ['FB399253-6632-4FA6-AE7D-8AD2342B3DBB', 'S710PT'],
    ['15A0CD0F-D626-4D85-A27A-335ED1C978A3', 'S721'],
    ['77A7ED06-67A3-4A93-878C-5761964D4A6B', 'S722PT'],
    ['7B31E0BB-EAE5-48C5-AA0D-B5B23C4437D9', 'S802'],
    ['52A72623-26AB-4030-AB32-5D3AC350C70F', 'S808'],
    ['E8213F96-0AD9-4DB9-BFC4-0848FB0CCF6D', 'S808PT'],
    ['ACB70E4B-F914-4CE9-8AD7-B760D3B8DD0B', 'S815PT'],
    ['1EBBF82D-B5BD-4702-BD3A-A6829CDBC966', 'S852PT'],
    ['FAF518CF-1509-46CD-BE6D-18FB4CBF6138', 'S881PT'],
    ['D012605A-AB9E-41F3-ADC6-5620851393B7', 'S890'],
    ['E67217DA-5CF6-404A-86C2-6C73891593EB', 'S891PT'],
    ['2F100223-62A4-4E6E-8FE3-09D5E3B5E1B1', 'S911PT'],
    ['D498C77A-224B-4BA5-86F4-07C08DD0873C', 'S921PT'],
    ['67CEC519-743D-4437-862C-FD2E2A52987E', 'S943'],
    ['A59844EF-2630-411B-9CE0-68AA81A23EA2', 'S993PT'],
    ['6FE4FFF0-67D1-4967-BCB3-4FC5381E7AD6', 'Sch Stand Co'],
    ['96D50C2E-A687-468C-B1EC-A15961CA38B2', '0208PT'],
    ['093061AB-80FB-43E2-987D-4B91ABD286B7', '0226'],
    ['7C4149CF-04A1-4BE7-802F-EC7BE5076546', '0310MASS'],
    ['4B4CBC8F-97A0-47B0-B968-E40F02250D39', '0319'],
    ['2D743F3A-0AE0-43F6-83BD-857A1464FF4F', '0321MA'],
    ['7ADB2E4B-5E41-4EC3-88CA-AE2B46FCCB47', '0322'],
    ['FE4F6374-1E84-42CA-B296-867DB81E5DD9', '0330MA'],
    ['18100BC2-D63A-468A-976F-CB6913F5C7C9', '0330MASS'],
    ['92774EB9-5FCF-44FC-BC74-50BC2238336B', '0330R'],
    ['CB565CA1-EE0A-4B3A-815D-2BE925F741E9', '0331'],
    ['E8E97576-D2CA-4A92-997B-2C071A2A1569', '0332MASS'],
    ['CFEFB1DA-63D0-4A5B-905F-B996B44D5305', '0344PT'],
    ['5EB29DF9-46C5-4009-8624-54557F22FC8B', '0355MASS'],
    ['26BFBD48-25FC-4D3C-B041-0C6B14086199', '0391MASS'],
    ['9D7C9501-F875-4EDC-8173-D04155ACC091', '0391PT'],
    ['3997B148-83F5-4CF3-BAE2-26E3194262C7', '0393MA'],
    ['C6FED9AB-0D08-4269-BA99-DC0054DB8998', '0394MASS'],
    ['7064D6B7-4B4E-43A6-81DE-9B9BA3DFB852', '0395'],
    ['8FFF7FD7-558A-491D-9054-5B3ED0DEA034', '0406PT'],
    ['1BF78241-9B28-4C52-8399-5C550B1E9781', '0407'],
    ['92B80A14-FDC5-4A51-BF42-2859DAF09B87', '0414MA'],
    ['6529FBF0-BE31-4FC9-9041-88DCF66AAD3F', '0414R'],
    ['346D2EE6-50D3-42BC-A0B8-4DF14F4EB723', '0419'],
    ['84547F08-4AE0-41D5-BEEC-8AD18E546857', '0429PT'],
    ['8DE9C159-C115-4001-943F-99BDB21936CD', '0440PT'],
    ['77DD8F31-E4AD-4CD7-828F-712937BB48F4', '0441PT'],
    ['AEEFF40D-8DC0-48B5-BA81-D42FBF2CAADC', '0442'],
    ['85B1A9EB-6FE3-4C84-95D0-2132CE261FD1', '0442PT'],
    ['730CC0DC-C05D-4A57-8F2A-16629555D2F0', '0455MASS'],
    ['122244A5-FD03-4140-8C59-B4C081AE9262', '0455PT'],
    ['4388F84A-C03D-40B5-90AD-FBF24B1DE932', '0456PT'],
    ['C7A8473C-C0F6-46FD-8CEF-B35544D20CA7', '0458'],
    ['BDE8D4A2-1466-4F6B-961E-BE32F9733D15', '0502MA'],
    ['77D42F4B-7168-458A-8423-61C61E6ED4E7', '0506MA'],
    ['853BBF5B-F04B-464B-B921-E0A6642F8518', '0507'],
    ['61B47B2E-E870-44D3-A54F-230EE7B4AF29', '0508JS'],
    ['9F754D9C-0448-40F2-AACC-B11A242ED984', '0508PT'],
    ['C7B07CF4-4D72-4EDA-A562-DCD1911569D8', '0511MASS'],
    ['11DB3C29-D105-4E57-815A-685A6FD8FCB6', '0514R'],
    ['9D2BECE6-76DC-4167-8F97-C12242023068', '0515PT'],
    ['33E50BDF-E106-4AE1-800D-115AD795DE25', '0518'],
    ['9C195902-92AF-4E09-96AC-EC3D2D05E9EA', '0533'],
    ['F9042F2F-4421-4093-8481-71286C20F627', '0543'],
    ['BFDB537E-3257-43FF-9CAC-F5C68755BF44', '0556PT'],
    ['84FCCDAA-6D28-4F01-8A31-BA6D5D3A1A16', '0557'],
    ['AD4B96A6-D006-45D9-879B-3C770D8D3168', '0612PT'],
    ['15EFE547-1F9E-4635-A3F5-F8ED71935711', '0614PT'],
    ['3BD64E13-D675-469C-A197-E7E400B95D71', '0616PT'],
    ['FDFDE127-7BD7-4880-9858-135AB1E414B5', '0616R'],
    ['80B1C3A3-A8E6-454B-B39F-DF45C97E76E0', '0618MASS'],
    ['042E9513-DE0E-4478-A89D-C03EC3694AA2', '0620'],
    ['2779D058-F35C-4472-8099-21408ABD7BA0', '0620MASS'],
    ['FA3F847B-A034-43D1-BD04-44255CC70A11', '0620PT'],
    ['911764CB-3F58-4678-BB4D-1977BF1C3887', '0623'],
    ['124C276C-AEA4-4E5D-AD4B-DB0A3FABA402', '0625'],
    ['A0D654D7-7EC4-4C06-8BD5-4863483FE781', '0625PT'],
    ['098AEF11-FB48-4037-8A1A-EEF3156AA042', '0630PT'],
    ['E42EBF15-B953-479F-AF1F-A4E49EB9C62B', '0632MA'],
    ['BFE3BA99-9C3D-45E3-A2ED-3D343CFB91A8', '0632PT'],
    ['C39EF870-D4F7-464D-B37D-2B11E5D40E0F', '0633'],
    ['E750721D-D10F-46BC-AFFA-7D1AB78A94D9', '0650'],
    ['D3C3B1E8-E874-4985-B4C9-F00EB7337B90', '0650PT'],
    ['F51E41DE-BB37-499E-88C2-793D73001E62', '0655'],
    ['3FA10F2A-0835-4DB8-8545-C05D03238F77', '0660'],
    ['4B9E0308-E9F7-4505-B567-A151A411222B', '0675PT'],
    ['F0A8BF5F-2A65-41CC-99E7-7FA98C07C205', '0700'],
    ['2573D6A6-03FD-4D69-85B5-0F578EAB4193', '1016'],
    ['4ECC6D13-9336-46D8-9A87-859606160A3C', '1020MA'],
    ['8C6D8935-9B21-41F1-9217-6C3F8BD8AD68', '1027'],
    ['2176838B-5C23-4489-B866-54A01D59DB93', '1028BMASS'],
    ['7A952478-7AB6-4739-A576-D5C1B372D985', '1030'],
    ['F7B01534-F042-401B-941B-002DFEBBE629', '1031MA'],
    ['03F3CCA1-CE0B-44A9-8FCC-B2527ABD2658', '1031PT'],
    ['6F842019-A63F-4A30-A8F1-116D62318F7B', '1032APT'],
    ['505C6475-AFFF-4AE9-BE3B-860A5D4912F0', '1032CR'],
    ['698EAB0C-C4EE-4C74-9732-AF38DA6370C5', '1035'],
    ['29A73D86-5B98-4124-82D7-BB774A122B35', '1037MA'],
    ['9D255104-8FE6-4DD6-A4E4-E6D0FB193B8E', '1039'],
    ['621FD962-02E5-42C2-90E4-54103ACD7562', '1039MASS'],
    ['2F7A729A-3B5E-4850-BA48-84916A1450C9', '1056'],
    ['9DDAC99B-BA0F-43CA-B297-8E03683D83AC', '1059PT'],
    ['45919F56-7AB5-434A-A81E-8CD369571A73', '1060MASS'],
    ['BE2E61B2-1884-435E-87CE-24A2FA62AE19', '1083'],
    ['922F6119-804F-4F9C-9160-F6312FD867EA', '1046'],
    ['0D96C9D7-CB69-41B7-B8F7-F4800CCC790D', '1052'],
    ['34E0F150-91BA-46DD-9AFC-34E71BF859AC', '1060MA'],
    ['56C7051D-F82D-4684-AE3A-66B7F73926C3', '1061'],
    ['445632CD-1E1E-4375-B7D9-8560D2386D9C', '1061PT'],
    ['53042AA9-13E6-435D-A46F-7E1742713F95', '1064'],
    ['C2427082-788C-4A54-8958-04613A548422', '1064MA'],
    ['96C848BF-88CD-4F5D-8B75-875F6A55E1FF', '1090MA'],
    ['31F90D5B-E5F3-40D5-AD86-2C46FC140A29', '1091'],
    ['ACB04AFB-1A72-4BA5-AB14-3380C1E341F2', '0041B'],
    ['47AF603B-7805-45BE-A3BB-77EF080E44CA', '0041C'],
    ['865A494C-B772-4FC6-95B9-B721DF574DFA', '0205PT'],
    ['7BA34DAA-9C49-4989-8774-68103448D3B2', '0206PT'],
    ['80ED42D5-4F75-4E9E-AA26-6A3BF6A16915', 'A512MA'],
    ['D1BF3624-FD8E-485C-AEE1-AD93680DB7CC', 'A514'],
    ['9246B8C4-863E-468A-9945-2405600FBCC1', 'A51C'],
    ['3ED575DF-A57D-4C75-8511-02EDDA61C388', 'A51FMA'],
    ['D3733181-52AE-44DA-97DB-52E4A9634DC7', 'A51S'],
    ['3F87734A-0482-446F-A145-6B58F50FDF2C', 'A51SPT'],
    ['8A45D702-68BC-4E81-A963-7F14A63FE934', 'A523PT'],
    ['7DEA9FDE-EF86-488E-82D7-463677CF43B4', 'A524MA'],
    ['59D68072-83DF-493C-9DCB-565B59F8B655', 'A526'],
    ['E2A2C61E-C4AD-461E-A550-D0DD91015BA1', 'A550MASS'],
    ['42ECB458-C07C-4662-B29B-7BAA72AF10E8', 'A56A'],
    ['432AC2C2-0CE4-4FCA-806D-81B13608F047', 'E026MA'],
    ['15556E15-4434-42F2-B76A-7582B498A95F', 'E027PT'],
    ['0E9A46F4-30F4-4A72-91BD-1E46CCDDE0B4', 'E029'],
    ['17513186-771C-4520-A74F-C04A6B4D9B0E', 'E034MA'],
    ['557A19B0-2525-4306-8405-9B465EA182D1', 'E093PT'],
    ['1F099BA4-EC23-49F8-A8BE-C1D3A92077F8', 'E165PT'],
    ['E2C26D62-46AD-42B7-8752-A4046F842489', 'E166'],
    ['8AC53854-7E8E-402F-A275-F054D92B265B', 'E212'],
    ['52A29434-D4CD-41B6-A43D-CB1BE3A6F4D0', 'E212PT'],
    ['877A49CC-1B95-48FD-9155-4D036F891AC2', 'E233'],
    ['130AECCA-4D1F-450B-A4E9-81072D66F532', 'Excpt Std'],
    ['9184773D-AB35-49F8-B741-53B5055F424E', 'Media Spec'],
    ['4E0F848C-0CAF-4B9A-9273-E30710A29AE6', 'NN40MA'],
    ['298DC03D-AC9B-43BA-A4F2-34E96206F44A', 'NN49'],
    ['B7E88F61-1E87-445E-9823-7E2EAFE89522', 'NN65MA'],
    ['596C0E4E-ABF3-424E-A05A-936D4D0364B4', 'NN67'],
    ['03424C58-1921-4F4C-9748-29237A044A58', 'NN71'],
    ['D36846BC-D1D3-4D5B-92EB-8CF8CE94A7BA', 'NN72MA'],
    ['5051F99D-431A-4072-9FC8-9525F7BBDED7', 'NN91'],
    ['AFDD0F11-0DFC-49DB-8001-3B3E5781F065', 'S032MASS'],
    ['BE091AAE-6B1F-4004-BB4A-E2970635E9CC', 'S050'],
    ['B594C43D-0169-4ADA-A169-08FE5DC1012F', 'S060'],
    ['B7C2E4D7-BA97-4203-964E-30D5CFE43536', 'S111PT'],
    ['57465E52-7407-43C0-BC9D-BD4B82DB020A', 'S120'],
    ['A3B030A4-322B-4165-9F73-E48C2AE7F71E', 'S122'],
    ['560502A7-E56A-4BB4-8288-FB8B889D943E', 'S124PT'],
    ['BE106583-8022-409B-B69E-DD1A08E9C5AC', 'S131'],
    ['09240BE0-A74B-4EA7-80A9-1F3BFF16579C', 'S151PT'],
    ['5B27DC65-E4C5-45BC-9420-A04587C763AE', 'S152'],
    ['EB2B4826-E6EC-43A2-9FC2-F9F00476DD50', 'S160'],
    ['B656097F-FEC2-4487-A1BF-CD024D2C712F', 'S160G'],
    ['6E277014-4AFF-4B8C-82AB-D33A8C66FA0D', 'S161'],
    ['5F41D629-C503-410F-B3F9-23EE9E7A4C03', 'S163B'],
    ['24DCC77E-CD1C-4BBB-A8DB-9FCE3D8C0AFB', 'S163C'],
    ['4EEEAC26-AD5C-434D-A094-285380B87FF4', 'S163I'],
    ['1F76822C-9357-48AE-9089-642568A2FEB1', 'S163MA'],
    ['EB7CDE56-D37B-473B-9788-D89244ADAFC4', 'S164A'],
    ['8DA13827-2B77-4BFA-AF7A-4CE71185C435', 'S164C'],
    ['8EC6D76A-B4BF-4D1B-835A-29B355B70912', 'S164D'],
    ['88DD7E57-17BD-4A2E-A30D-07593E2F2236', 'S164PT'],
    ['73AC7FBB-5F46-46FB-A200-C266161514FA', 'S165'],
    ['1CA5D3A8-A5FA-40C8-A8FB-92C7AC3F0A24', 'S212'],
    ['204DB850-2800-4D5E-B25E-D1F5E16AA378', 'S232PT'],
    ['E90D6B7D-0064-4DEA-BF75-59786BE73690', 'S300AMASS'],
    ['DEE53E03-411C-4636-99ED-BB2D20040D5D', 'S312PT'],
    ['AFCD8366-86C6-455A-B5BE-F93431C1AF20', 'S418MA'],
    ['62657486-DF64-4E25-9B3F-C868CE082548', 'S419MA'],
    ['F729C406-3083-4C8B-BF53-80CF154966FB', 'S512'],
    ['827910B9-3A19-4218-9E24-42F81878C874', 'S655A'],
    ['7E909FB2-D353-4928-A8AD-3564060A99D0', 'S657'],
    ['ED0B7F9F-746C-4DF1-8D81-18C6ACDACF49', 'S661'],
    ['AA89061E-72E6-405B-BB4B-D7B6B9910DFB', 'S680PT'],
    ['580E273F-4DC6-4AAB-A184-DD34EB1D8E8A', 'S701PT'],
    ['6D3EAABD-5864-49B6-808F-1D20FC6DADCE', 'S720'],
    ['13F172DB-2EAC-4C28-93BB-4EA4F3A33FE3', 'S720PT'],
    ['38F6F26B-40C6-4F94-A10A-0CF1E3B998FC', 'S721PT'],
    ['BEDD9E71-FFDD-4F18-8F6C-0BF4FEAC5115', 'S722'],
    ['3DE2D388-963D-4F93-A2CB-19E3D72E7E4F', 'S733PT'],
    ['D291C760-5ABA-49C0-B6B8-6864C1CD372E', 'S739'],
    ['B5C9A04E-CE49-4AA0-A04B-AC24CA85D4B3', 'S804'],
    ['37CEB142-82E0-4A80-9FD5-BFDBC3A3BF2B', 'S813'],
    ['26FF3ABB-A167-4F6F-94D3-20FC43253B87', 'S855PT'],
    ['FED1AF91-03D7-4268-A09E-B5E509E9B359', 'S861'],
    ['68108234-7855-4C49-A18D-99E0AE13AA36', 'S871PT'],
    ['4CC7874F-4F61-4DC9-BC68-8CE5D3106EFB', 'S892'],
    ['758AFE8A-5736-4E13-ADFD-41D275B31289', 'S892PT'],
    ['EDE515F0-E366-463B-AFAA-428FBB4E56D6', 'S893PT'],
    ['994FFFB6-0DBE-49AD-8620-13CC487D98F8', 'S910PT'],
    ['CB57BA7C-C747-4E8D-9831-D99696C4F01E', 'S911'],
    ['7617E084-8498-4709-8ED3-A402E586C587', 'S941PT'],
    ['FB04EC6B-ECC0-4550-BE30-7EFCBF84AD07', 'S942MA'],
    ['B3EFE8AA-12FF-41A1-9D85-5E5FF772197F', 'S981'],
    ['D7E5F286-36B3-474C-873B-BC6FB8B80D2F', 'S997'],
    ['FD828026-CE6C-47A5-9146-7A82161ADC97', '0223'],
    ['E0FFB676-4C26-4E2D-A5F9-E0359E87CE2F', '0227R'],
    ['CE3BDAAD-67DB-4E4F-93AA-B3B9C0C758D7', '0310MA'],
    ['ADA79210-17FD-4387-B9E1-0CE87526792B', '0310PT'],
    ['D9B19F62-193A-45E5-B1AB-CF1CF9797CB3', '0317PT'],
    ['928D8D57-97F5-4A26-873C-6212A8B08B43', '0319MASS'],
    ['10314163-F940-4EC1-8F34-AC0BC9F3A50F', '0321MASS'],
    ['EA0BE575-4AA0-4C00-A305-B7E69EA4053F', '0321PT'],
    ['289110A1-6FFD-4DB3-B6C5-C4695BFF891F', '0322MA'],
    ['7EC79AE1-7EBF-4125-915F-37E5C74FD4F8', '0333'],
    ['A70C4BED-F563-4F77-B665-297B7C3AF55F', '0333MASS'],
    ['2224B477-A6B0-416B-B8EF-FAA733F5ADD6', '0342MA'],
    ['DA43749F-5317-4DD9-996B-16E6868B295E', '0343'],
    ['503EFE68-0E0B-4967-8812-2D11FCBF9388', '0345MA'],
    ['67F29C9D-1A8B-4C3C-B9F1-B82BA9282621', '0345PT'],
    ['12C41A1E-7B5D-409F-979C-FB918E93662E', '0349JS'],
    ['7667733C-F8D8-48BD-AE91-BCDD7A8906A4', '0356R'],
    ['2C76F5DC-B5AD-4CAB-9A15-F4FE01AD747C', '0357MA'],
    ['08AD85A0-174B-4CB8-8909-A21E952A1FFA', '0358MA'],
    ['D88FB39E-1CC9-4B03-B215-AF8148DDD99C', '0361'],
    ['EE124CF0-0B3D-4623-90F7-AC8A76CEB787', '0362PT'],
    ['25949A3E-B998-440F-A3A2-63C304078D72', '0363'],
    ['EE99F108-B22A-452E-94D6-F4E7310E3C23', '0399MA'],
    ['38EEA206-AB3E-4AA3-A613-1CD8729E7D31', '0407PT'],
    ['66F62741-3D94-40F3-BCAC-5D918250AC9F', '0409MASS'],
    ['91D62D32-56E9-49F1-B482-C173C9D68D5C', '0410MA'],
    ['DA7F7D14-2A2C-46F0-B1A0-2B277E2A7DFC', '0411MASS'],
    ['07873D58-49CD-4A5C-9D5D-EA166CA369EC', '0411PT'],
    ['8DC88FD5-46E3-42BC-B1D7-AEC2E60F1AA0', '0413'],
    ['02120EE5-E561-4ADB-A0BE-9D3FF6EF48E2', '0415'],
    ['6D4FD26F-0C13-4F3A-8010-2D6961EA2AEE', '0415R'],
    ['0A6F6004-0D81-4686-8C44-393C9339A150', '0417'],
    ['1A42A582-1065-41FF-8384-31A46C908885', '0419MA'],
    ['E475CFED-8E38-4F45-B98A-CE6A88684DF8', '0421PT'],
    ['D6DFA98E-9043-468F-978A-CDC5C755F210', '0433MA'],
    ['E386BBC9-9751-4DCD-9EA7-2379A05E3153', '0449MA'],
    ['83E7E639-908D-40A6-90B7-F4E1EFD2A4EF', '0449PT'],
    ['ECFE7E63-AD4D-49F8-BBEC-B7A0B07B423A', '0450'],
    ['7B010195-808B-485F-A779-C4108CCCFE0C', '0457'],
    ['F9130FB8-7AA6-40A2-8CB2-8ED6F24172D6', '0458MA'],
    ['69924244-1811-4260-B664-B3D9E5095075', '0485MA'],
    ['1D6420E9-EBB9-41A0-98F2-6A52A0891E90', '0507MASS'],
    ['CBFACD58-E093-4E06-A011-D2D1C7AB4C23', '0507PT'],
    ['7A62DA08-B664-4EEC-A3A2-EE2559B312FD', '0509MASS'],
    ['117BD7AF-5F80-4354-A1D6-44574B0D7B00', '0510MA'],
    ['C4A6EE79-558A-4B56-8033-866E1EEA9D8F', '0510PT'],
    ['D9EDB4E7-46B9-4B5A-A34E-B5195E79CF85', '0511PT'],
    ['B36CE769-5A0D-476F-A536-FCE8641CE554', '0512MA'],
    ['5EA15467-5DAD-4FFC-B0B5-DFE2FFFB26CF', '0514'],
    ['2320B8E1-B344-4863-8D12-727C74402FB2', '0514MA'],
    ['8062A7B2-C6F1-46D1-8689-97215242A9F2', '0515R'],
    ['A864B001-FFC5-4E2B-81E8-95939584EB94', '0516MA'],
    ['9C7DC6A5-1E6A-4D2A-A8E9-B975018399BF', '0533PT'],
    ['157BA353-EEF0-4F7C-B38D-682532C55466', '0540PT'],
    ['43236CA6-1961-40E6-97F2-D29326F9CF77', '0542PT'],
    ['2477F825-5411-4F44-A8B5-903F5CAFC455', '0543PT'],
    ['758DC28C-9D5E-41BA-B6B3-4E09BF31F9F0', '0548PT'],
    ['65822D33-7FE6-466A-88A1-77385643C073', '0555'],
    ['5AF7956C-8790-4663-901C-9BDD7E79F4AD', '0556'],
    ['C145C7C3-A4A7-4DD8-BE82-C8A34AC9467E', '0603PT'],
    ['F62BE969-9A04-46A6-AD1B-15DC09DD1A32', '0605PT'],
    ['A38F8339-E825-4314-A026-6266AF34D0FE', '0614'],
    ['F7E9E8E2-9309-4EB4-BB65-8BC87F7B0BED', '0616MA'],
    ['84C8F4B8-AE1D-4664-A09A-18AB085B3AB9', '0617'],
    ['18E6FC09-5FBE-4AC1-917B-8DD95B7326E5', '0621MASS'],
    ['27F33DF7-5344-4249-823F-2473E586EBA2', '0622MASS'],
    ['50277BAB-AB7B-4E2A-8EEA-BD9F91A5599B', '0624R'],
    ['8DCB735F-1D60-43CD-8B8A-FF079C8C54E6', '0626PT'],
    ['83202A58-3A5A-44E3-9284-3ABD872D0C2C', '0660PT'],
    ['145623FB-8FC6-447E-A933-D30AEFDABA45', '0670'],
    ['93187B7F-D64C-472D-9F76-26D0B13537A6', '0680PT'],
    ['E2BB0284-8A0E-4A54-93FF-F45A58E9C43C', '1022R'],
    ['815B1DE0-7861-4D50-AD03-5A0E6A05D3C7', '1025MASS'],
    ['5B09F0E8-D0F2-42B9-A1D5-9F390023DB2F', '1026MA'],
    ['C7DC70A3-A51D-496B-B901-68A04D7B7D87', '1027PT'],
    ['1CD79930-F3FF-4823-9F2B-A0854A337A42', '1028BPT'],
    ['94020C0C-7CDA-4F4C-9EE0-2BCC7D144181', '1032CPT'],
    ['ADAAC68F-1375-4361-AA04-FACFA4B831DE', '1032DR'],
    ['99FCC22E-044B-4A2B-9DAD-56C4B71FF425', '1035MA'],
    ['3FE1FC64-136A-44F8-A2C9-E127C79F6D7C', '1036'],
    ['2ED3357A-7E14-4C08-9488-8BC112F13E1D', 'S940PT'],
    ['16E1C05C-7C4E-48DC-A06C-D75BFBE71F65', 'S941'],
    ['1E34669A-7530-4155-92A2-430D5F47D3ED', 'Sch Admin'],
    ['89651388-F46F-4610-97F5-0CA0846CAD70', 'Science'],
    ['B8283349-714C-44F1-A9B8-3B3DA8C8DA7B', '0008'],
    ['09988418-AA93-4654-8E90-672EB0BFDC24', '0030'],
    ['A42F4F52-6DF0-44D2-B2D0-B6395D890B0D', '0041BPT'],
    ['F8A04FA4-63ED-43BC-9A13-8547B93778E7', '0205'],
    ['10A7105A-D8B8-42CA-B253-2C09CB873DD3', 'A511'],
    ['074FCA2C-846E-402B-B5C8-37BDD26901A3', 'A516'],
    ['6E473CD1-7AC7-415C-A386-2709D88B354E', 'A51BPT'],
    ['F120AD1D-60B7-4292-B010-8780A29F6EF9', 'A51CMASS'],
    ['88592900-1200-4E73-877E-8EF1D9EA23FA', 'A51DPT'],
    ['AD829F23-BF2D-49CF-9E08-F7925A6FACA4', 'A51EPT'],
    ['24F6DE07-C144-42BF-908E-55ECFE636985', 'A520'],
    ['D3ED0D43-6A9A-4BC3-A5F1-4136EB7EE873', 'A522PT'],
    ['DC4D1E12-1D36-4A80-A0BE-90E13E439F4D', 'A527MASS'],
    ['03284CEB-78EC-40DF-882D-D3B031F300CC', 'A550'],
    ['DB4443A8-1778-4A0F-89F1-392037994191', 'A550PT'],
    ['B254EFA3-E5D7-4422-8951-A5288CF36B83', 'A55A'],
    ['F0883186-FD5B-4C95-93D6-350EAA58BF20', 'E001PT'],
    ['327BB6BC-C87E-4344-9DEE-9639002DB1A4', 'E034'],
    ['1F7E5D8F-36C3-4E60-99C0-2C3A9F8F5ACE', 'E034MASS'],
    ['C728DE06-C79E-4341-9855-EB00C9090F8D', 'E038PT'],
    ['E4F538B7-66F2-49A2-9BB7-6ECD3A31C093', 'E049MA'],
    ['CCA04B83-D006-4DF8-9FBC-2B75C1E48272', 'E094'],
    ['34795D50-D8FB-4835-8122-736D51B3662F', 'E095PT'],
    ['BB4257A2-5B0C-417C-B9D5-BF48590085AD', 'E166MA'],
    ['D8859033-ABFB-49F3-B04A-60AA316466DD', 'E301PT'],
    ['FA45943F-C909-4FDE-9B15-7D3E3B514CF2', 'E302'],
    ['D3970A69-58B6-4F48-8EAE-ADE69B26C309', 'E303'],
    ['84276437-E38E-4233-89D7-7E5F5D767B24', 'E305MA'],
    ['AD07C1B8-44FB-42F4-A9FB-5A33D7AD711E', 'English'],
    ['049AC50A-5F8A-40F1-89D5-7F7D20639774', 'Guidance'],
    ['F1C3A46A-29CD-42B7-BC4F-E8F90BAA3B3C', 'NN60'],
    ['0E88A4AB-8649-4738-A8A2-ADF24901E3BF', 'NN60MA'],
    ['B4DDBD63-3A94-4D0E-9890-9309EEA5823A', 'NN62MA'],
    ['0949886C-EEEC-4AE8-B8A4-93C9CACBBE6E', 'NN63MA'],
    ['E77CD6BF-0F8C-41A8-89F2-50799CEC0E32', 'NN70MA'],
    ['18119DA6-605B-4286-B5A1-6406972CE8C3', 'Resource'],
    ['FFC41740-DDF0-4474-9EE2-DC1847777672', 'S012PT'],
    ['F2627EA2-42E5-4704-99F5-3E3154BBCC68', 'S016PT'],
    ['83A76A20-2E31-41BA-AF8A-C2B21A50F0BC', 'S023'],
    ['2F9E075E-24E4-4E09-966D-A5F21EFA5FE5', 'S025PT'],
    ['07206949-8B5A-4FD8-B97F-1546C3DC72F6', 'S031PT'],
    ['4F98DF3C-AEC4-4412-9894-82A2DD01991F', 'S032MA'],
    ['DCCBC73A-D31C-4DA3-AF16-1892D032323A', 'S037'],
    ['83093617-2F93-44EB-8D29-5C99947F3E44', 'S042'],
    ['4D2EE183-B373-4FA6-8D29-AD8717364023', 'S043MA'],
    ['0C76C65A-A2D6-457C-8CDE-D7D10ECA5AC6', 'S057PT'],
    ['876D118E-0394-4FBA-8607-8F77D231E7AF', 'S062'],
    ['61E31541-88BB-44A2-BAC9-84D7EF0D1BD6', 'S076PT'],
    ['B22C5085-EFFE-47DB-88F4-F545F8E2D7FD', 'S081'],
    ['C067C6CA-FBC0-4D75-ACC5-20E5844E0C47', 'S081MA'],
    ['237BC63D-A0B5-4502-BBD4-FFA7FDD5221B', 'S127'],
    ['AAF1ACAE-0752-4F53-B066-60AB49A63733', 'S127MA'],
    ['94C02985-355C-48EB-9FE0-06D349B53936', 'S131PT'],
    ['6F7823B5-F502-4877-8ED9-FAD908E2FA9D', 'S151'],
    ['8AE905D0-28F1-4811-AF0D-4914B93561F2', 'S152B'],
    ['20BB35C5-65D2-49E3-89C5-5445FD3266E6', 'S162MA'],
    ['82E806EA-0ACC-47A2-BB3A-487605A04272', 'S163D'],
    ['88A82E21-797F-4278-B70F-752C9D312BAC', 'S163E'],
    ['983A84A5-1CCA-429B-ACDA-EBBC8F8CE46D', 'S164F'],
    ['14AAF6A8-0018-4265-BAE1-B3648259D666', 'S212MA'],
    ['94A6CE6B-5951-4ECA-8C78-D90F1A175E10', 'S212PT'],
    ['97DDEDBE-0CBA-4E0C-B357-BB5E3B115AF5', 'S214PT'],
    ['6610C68B-3CC3-4DE1-B467-0152B532EAF7', 'S222MA'],
    ['7684DFED-79D6-41A9-9ACA-6614E4E7CBC4', 'S232'],
    ['4FD0C12A-2492-4244-9FAC-34C8338B8626', 'S233'],
    ['C848B462-0D68-4C1E-9C99-B92EEFA64FBE', 'S233PT'],
    ['9596865C-30AE-4AE6-B305-DBBCAB1DD225', 'S240'],
    ['3FDB9726-6723-450C-AF81-42E876E6046F', 'S242'],
    ['B8013F46-540A-4D13-9BD1-36CFA7C8A5DF', 'S261'],
    ['D972469F-D640-4452-B47F-5D132A4EF71C', 'S300AMA'],
    ['D1AEADE5-06AD-43C0-AB23-0BAF07B88015', 'S301AMA'],
    ['9139B3EA-77EA-4D67-83A3-C74B7837AD8C', 'S419'],
    ['F26911C3-D4B1-4861-844C-24895570B08B', 'S419D'],
    ['20359975-948A-4943-82FF-182F01820E8B', 'S419DMA'],
    ['30A45013-1380-418A-9A85-70D460D88BEB', 'S513'],
    ['8E00F2C2-D33F-4D9E-8720-C541F9666A38', 'S656PT'],
    ['B1498D11-ED95-42A8-AD5A-0C8E93B29C30', 'S670PT'],
    ['444522C4-04ED-4AFF-BF5F-D3ABECC59DB9', 'S691'],
    ['79681BFD-E9F1-4FE9-910F-6C9589F73B5B', 'S700'],
    ['3809F865-EEB2-45F8-9289-F6E64116CCE6', 'S702PT'],
    ['F17A89A7-EA8D-4AF8-9452-A9C9D184DAEA', 'S730PT'],
    ['F9023F11-0ECB-4C69-9AAA-8271173A1AA2', 'S733'],
    ['3D725F9F-809A-4D6D-A660-5690C0C0835C', 'S801PT'],
    ['734D5CC4-B674-49FF-B49D-BF5EEB13165D', 'S803'],
    ['9498B862-75BC-441D-8C95-57E3C9E88795', 'S809'],
    ['5B84101D-E59A-487E-B8B7-B67ACD4DAFE4', 'S810'],
    ['B9F85CCE-999E-481F-8FC5-FC65C1D85C26', 'S811PT'],
    ['15D6DE80-6494-41DE-9D9A-7151FC2CE35C', 'S862PT'],
    ['B80B57E8-FD27-4AB6-955C-0D325D87F33A', 'S943PT'],
    ['424A643C-979A-4B74-8D35-C5D232547DD4', '0300MAEP'],
    ['1A704CF5-AFD3-4BCB-ACFB-B15E507A914A', '0307PT'],
    ['ED3F3571-D0A5-43BF-A184-B9ADA2EFE35E', '0309MA'],
    ['3BD8A4C2-DC97-42BA-9CE8-EA24FC13B27A', '0309PT'],
    ['CC08B093-0865-404F-A418-461FF8067F0B', '0322JS'],
    ['E26B2BA7-AEE8-474F-9D3D-E62ED97B7AA7', '0331MA'],
    ['7F3CD7D1-8707-49AF-8ACE-229FD85293AF', '0334JS'],
    ['68E99CC4-F70B-494B-B0FD-264DC1569067', '0343PT'],
    ['9C7B2E95-0849-4FC6-983A-A5078F3843E8', '0348MA'],
    ['6B9BBB46-DBD3-445D-B7F2-A76D65BB091C', '0349'],
    ['F58DD47E-5210-4F5F-A0C1-3690239C1BAC', '0350'],
    ['C6F3AA0B-22CC-43BF-88FF-41CADF22F2D6', '0355'],
    ['323F9376-4F6C-4841-84D4-F25D61DF1253', '0358'],
    ['6E16EC16-B421-438B-AAF3-95E5796CEBA0', '0360'],
    ['330E7C94-92FA-4EFB-B86F-9E36C917E9BF', '0360PT'],
    ['D6E3A66D-8FB6-4222-8FEE-1E212903B28B', '0362'],
    ['0869EE01-AFF4-476A-AFF5-FF1F6D9B3EA9', '0388MASS'],
    ['199F4220-0010-4C82-B96B-8CB850BA6986', '0388PT'],
    ['37CCC535-C8E9-40E2-BE85-2180CBAE6CCE', '0392MASS'],
    ['4217F2D9-01EA-4384-A0DD-75531E2769F6', '0394JS'],
    ['CA7B3786-4F19-499F-BF5A-3D0EDE5E2829', '0394PT'],
    ['D6A73822-624E-40DE-B026-837B17FCEA9A', '0396'],
    ['057CA970-2954-4689-9F6D-1BECA90CB913', '0399'],
    ['741E8497-D277-4106-B7F8-D7099741C2DC', '0402PT'],
    ['9B448084-397C-43C9-A0D1-AB7AC1BA969D', '0406MA'],
    ['0DAAC88A-6BD1-449F-B6E4-4B81DF90A840', '0408MA'],
    ['E1C40FE8-BB94-4138-B040-9103547B187C', '0409MA'],
    ['D742D882-B772-46AA-93C9-9DA985FF3F0C', '0413MA'],
    ['FF1C9DBC-CFB3-40E5-86F6-4BD9258A9DC5', '0413MASS'],
    ['BBE65FB1-7D4A-4C73-9C0D-8FFB4C2AE03C', '0413PT'],
    ['95A82B35-2B24-4046-9928-1F0F03B4B75E', '0414'],
    ['4E44C0D0-E732-4923-B7E7-04438584D1B6', '0414MASS'],
    ['F65728B7-61FF-4FEE-8E04-69A172FDFB15', '0417MA'],
    ['DFD35FC9-F253-431B-B5A3-D4ADBE706A77', '0429'],
    ['71DE20B0-0187-4016-BAF6-1420B35D88E2', '0457MASS'],
    ['0F35B41E-12C5-4BD0-B882-F09FF8A81369', '0480MA'],
    ['9E597F4B-6D37-4802-8B8A-AEA27EE2B2B3', '0480PT'],
    ['A8E91950-7252-46D8-B0FE-411ECB82B050', '0512PT'],
    ['5F1603DD-E353-462C-AB18-437DC03316A6', '0513MA'],
    ['FB533D71-7C79-4A6E-A888-B8C8B455B74C', '0513MASS'],
    ['54A2CB0A-6801-4694-A08F-6B48460E24CA', '0514PT'],
    ['5B64C386-4B9E-47D3-B0EB-2C6BE7857FB2', '0517'],
    ['03CA6D67-BBDA-4B48-868E-AAF0D2896515', '0517MA'],
    ['9571ECD3-170C-459F-BC15-C40A74B2F781', '0517MASS'],
    ['9BFEE0AD-6ABA-47EE-9622-66255347C29D', '0517PT'],
    ['E2071F10-1D3D-43D4-AA5E-33016BB0239A', '0518PT'],
    ['C95A389B-D368-481D-A931-B6DF3A22DD14', '0540MA'],
    ['F3C5EA31-F361-456B-85B9-C1CF90C87395', '0557MASS'],
    ['EFCC8F91-753F-48A6-B640-AB09EFEA5708', '0558'],
    ['C1E896F0-DFDE-449E-A21A-5177B2E48D86', '0599MA'],
    ['B90AFE6E-D78B-4FCF-9732-AFD748EF3F9D', '0599PT'],
    ['26EBD32B-2BDE-4C39-AD33-F858785FD745', '0613'],
    ['35611260-22B3-419B-9121-E62618DED3DF', '0617PT'],
    ['1EBFCCFB-8403-45AE-9006-18414047DD9E', '0618PT'],
    ['3F8D4F20-6D33-4F0C-909C-396375A9BFB9', '0618R'],
    ['9C10B714-20E0-4C70-8A8C-7A7366CBD687', '0621JS'],
    ['374CA0F5-BA08-47A5-8065-FB7AE1BF3C88', '0626'],
    ['650726A7-57E2-4372-9E90-7DB285308012', '0627PT'],
    ['57315F23-D8E0-492E-94D2-C166D4735F5F', '0634MA'],
    ['05DE5456-6891-421A-99E3-2D3731167ED2', '0634PT'],
    ['70AD855C-F752-4177-BE72-D4354CE1C43E', '0660MA'],
    ['CFFA53E6-884F-491E-9B5D-9EE7FA0C457B', '1020MASS'],
    ['95548E7C-E69C-463E-BFDD-EF724217C4C5', '1022MASS'],
    ['F0548B94-215A-43FE-83BF-7E0DB9CCEE72', '1023MASS'],
    ['01339657-E57D-4C34-B45F-FB0AA1280F10', '1025PT'],
    ['DB70BAC6-6864-44D4-AD6D-89267D70668B', '1026'],
    ['A3A7D35E-60CE-4901-A4E8-28A987FCFE9D', '1031'],
    ['EC0B8230-6EB9-4322-A740-4C97F47A6681', '1032A'],
    ['F9D35AE7-B81D-4A11-8037-FB3F5434E7D3', '1032DMASS'],
    ['DABE175C-FFA4-46DA-8175-95D6429A35F7', '1045APT'],
    ['AEE5C970-8C28-4116-8835-20F952660E7E', '1045B'],
    ['3531F78D-632C-412E-BE62-133B24FD0EC2', '1045BMA'],
    ['D1489122-0ECE-4D75-9F24-B584A1EA8E28', '1059MA'],
    ['B53CAC8D-6E79-4332-9C47-839F12AB7EDD', '0032PT'],
    ['A2E190FD-3BBB-47B3-ABF2-C4EB54D32202', '0036PT'],
    ['3C6A321B-A239-4F1E-A368-9E48BAC95BBF', '0041CPT'],
    ['B5F2602F-2ABD-4B29-B2A5-16B883C37FE6', '0203'],
    ['13B850B9-2047-43FD-B0F9-C0A1FF2A38D3', 'A513MA'],
    ['062953A7-AD38-4445-AD94-987380BB0977', 'A515'],
    ['E55F04C6-9ECC-436E-BC6D-BC92DCD6240E', 'A51A'],
    ['E69B7614-CDCC-4C37-9FA0-E505D9082204', 'A51AMASS'],
    ['3ADD4B05-C386-4238-8CB7-3AA86ED575BC', 'A51EMA'],
    ['637225EC-6DD1-47BA-BD00-B7BC7E2E8F3F', 'A51F'],
    ['D7925F8D-E96B-4726-B445-AE568B541BF2', 'A51M'],
    ['8E445231-468B-4A12-9DDE-8FA410745FA3', 'A520MASS'],
    ['83196A44-973F-47B0-8629-9FD044B499CD', 'A521PT'],
    ['71603337-B530-45F1-9344-3DBCFA58A55E', 'A523MA'],
    ['6A2DDC33-7B53-454F-86E7-E7B747A8675F', 'A526MA'],
    ['DCA478D9-8944-41F9-BAA1-9AC8C636137D', 'A527MA'],
    ['07A0A7F6-CDDA-4D01-9A3E-3EDB2EB69318', 'A530PT'],
    ['DCD7D096-5DC8-4C2F-B1B8-8A2F98990EAC', 'E091'],
    ['67BD003A-3D74-4A07-8C3E-CCF44B0B67FD', 'E095'],
    ['40AA17A2-C9AA-4BFD-82C8-80644BAF3EE6', 'E167MA'],
    ['7047A764-A06A-47D8-9E6A-2B9F1751BEEA', 'E213'],
    ['F7CA6D3F-78FE-482B-BA44-FA84884A2743', 'E214PT'],
    ['9930B269-4B3C-4031-B0E0-ADDA9A1A7660', 'E233PT'],
    ['DB1C8908-B070-4247-9D01-D08DE9AAFECB', 'E302MA'],
    ['6CB8426F-83E8-4C02-9B7A-3D83340404E2', 'E645PT'],
    ['D05CD9E2-9C66-4FBD-923F-A17CF4184CD9', 'NN49MA'],
    ['0CBAE920-9A72-4BC3-B81A-B6F985D121C2', 'NN50'],
    ['90A1F288-967E-4C1D-9266-2B1145BA1673', 'NN67MA'],
    ['5A0A8061-3305-47AB-B06C-22AB85CFB05A', 'NN71MA'],
    ['CBEB9B6D-DA2C-4B01-B985-71ABA1F80999', 'NN93'],
    ['4064D0F7-809B-44CA-8DA8-8EA7AAD95F90', 'Reading'],
    ['8A4675FA-AF78-4B2C-92F1-D43460358816', 'S011'],
    ['0A4A5926-4405-496B-8C87-D046A86CEED5', 'S031MASS'],
    ['2E549B0B-77C0-4027-85B6-F79ABCBB386A', 'S037PT'],
    ['8C97C196-57B8-45B6-8ED8-BCB38B8339FA', 'S043MASS'],
    ['5146F256-46DB-45DF-B513-0514882F54DE', 'S043PT'],
    ['700145A5-2067-4B03-955A-E10D812347C2', 'S046MA'],
    ['227E9CA0-12E5-4CD5-875A-039D7A8BC764', 'S046MASS'],
    ['68B00D9A-45D2-4687-BEE9-D4351676D227', 'S075MA'],
    ['77DEFCF5-30BD-4B0B-B638-4B199834EB9E', 'S082'],
    ['D255AB7D-B948-40FF-9A7B-823DCB9EF276', 'S090PT'],
    ['1D53DB35-4F0E-4157-A6E7-32B39BAC4F3D', 'S112'],
    ['76180D13-180D-4930-9F9D-A998949734BF', 'S122PT'],
    ['0DABC4F6-EF01-445C-A202-D5B615A09570', 'S123'],
    ['F76BFFFB-1C5D-4FEE-89A8-78B7A5133862', 'S151MA'],
    ['75236940-67FB-45A2-AD07-9AD15EEA1171', 'S152PT'],
    ['27925E1D-5169-4352-A6F6-0F9BA742FC5C', 'S160H'],
    ['C4D92122-0C1F-4852-A34C-1AFC6B476FAE', 'S160MA'],
    ['2CBBB4C1-2885-452B-BD13-DC27C037DC26', 'S160PT'],
    ['5FD29C88-C727-40A8-ABC6-9BF34F6E4585', 'S162I'],
    ['35F9D78D-319B-453A-BE1F-729E55CA3B9A', 'S162PT'],
    ['5528F396-A064-4CD0-B791-16D288291D56', 'S163PT'],
    ['8FD835CA-8776-47CC-A36F-11A7CCC5CD32', 'S213MA'],
    ['3848A28F-51DD-4E98-9D14-53E9215BC551', 'S239'],
    ['53BC2D9C-C5BA-4E22-990C-8A90BB3DCDF9', 'S301CMA'],
    ['222F1538-3D95-4C43-93AD-7A2535EF91DA', 'S311'],
    ['7D63E8ED-790C-4D79-A34C-5BCB12F9E44C', 'S311PT'],
    ['DE2E2678-3FB8-46C0-BF1B-641A6F44B1A7', 'S312MA'],
    ['1D1AD4DC-C79D-45CD-8FE4-EF5CFBDC35CE', 'S418'],
    ['34DBFE7A-6ED5-48DF-892C-87B2971EDD23', 'S423'],
    ['4B8FF781-AFA1-4D49-A8D1-BE303F75BB69', 'S513MA'],
    ['4FBBF886-3201-4414-BC3A-B2D48F2E2FD1', 'S655E'],
    ['5A4BF95D-825E-4A23-A23A-53CCB4FB9D92', 'S660'],
    ['51A34D6B-5ABD-4B09-94AA-AF09C345EBAA', 'S731'],
    ['C4CE2075-7C3A-44DF-AD3F-43D6C5714A19', 'S732'],
    ['F1369D2E-7669-4157-9D22-7525F07CF446', 'S737'],
    ['8B275CD2-0546-428E-9B7D-00230AF7F3A4', 'S738'],
    ['23332961-2AB9-4993-911E-5FB9F78DA4F5', 'S760PT'],
    ['1F428B66-A99E-4526-8D85-7ADE25B88E67', 'S763'],
    ['8E81D667-FA5E-488F-997B-CB84986D184B', 'S803PT'],
    ['0A60897C-2C07-461E-A40E-FC6EB7BB235B', 'S812'],
    ['F720D128-C224-41E0-9CEA-4C6AF2502636', 'S814'],
    ['D869A44C-16A6-46D1-8191-D1E3387B5A65', 'S840PT'],
    ['EBF8968B-8AFF-4C8E-8B99-3D7A4DAAB70A', 'S860PT'],
    ['7116535E-5382-448D-8DFE-F3321CB940E0', 'S871'],
    ['20D31909-129B-475F-80FE-CB7D2F9D1338', 'S893'],
    ['5989AA87-1E25-458A-8FE5-31EAAA61DDE1', 'S940'],
    ['8B06FE7B-AC73-4ECE-BC4B-96028155C221', 'Security'],
    ['9A8E632A-10F0-4F62-8241-93A63590B59D', '0224'],
    ['AFBAB0E3-B602-443F-8C30-AE167217E014', '0228PT'],
    ['5A306DFD-FB06-43C7-A388-C945D119469E', '0307'],
    ['F03EF9A0-4FE9-4487-8B74-A3FD91F2EAC4', '0317MA'],
    ['9FAF671F-7EBD-4A52-8FDD-39547C48268C', '0331MASS'],
    ['DCDFF59F-01BE-4305-A0A0-C4A4FD14B18F', '0332'],
    ['2B509806-A3B8-498C-BC3C-CD1EE5107C43', '0332R'],
    ['A46505D9-28F9-4F36-9E9F-C1A37F23325B', '0333MAEP'],
    ['F33AEAD6-79F2-4805-95A9-C10A86D0AEB8', '0334MA'],
    ['AA8BF10D-5722-46DD-B81B-8A822B324F52', '0340'],
    ['1C498121-BA3F-4981-86EF-9D711F825471', '0341'],
    ['9827EE74-C2EE-47A0-A700-91E430512C1F', '0341PT'],
    ['B78AC402-D073-49CF-9102-72C8929E230C', '0343MA'],
    ['F16E5787-DD92-4388-A712-583A4A2EB525', '0344MASS'],
    ['ECBE0472-4AD2-458F-998F-AE0AA4C4095A', '0348PT'],
    ['7DF96574-F257-4A8E-B9AB-96FADE2C7248', '0370'],
    ['AB03F1E7-9EEF-4FC3-A2CC-5F1D2E6CA520', '0392PT'],
    ['55C1198E-6497-44F2-9A39-202B8DF1FB9D', '0394'],
    ['4E2AAE55-ABD7-4137-B058-06CB0F691212', '0396MASS'],
    ['974B6241-EF87-4C13-8612-BB1A69D1587C', '0399R'],
    ['5922E13A-81F9-4B84-9E66-8BCC1FC5F76F', '0400MAEP'],
    ['CA9F7586-2AD9-40AD-A1DF-41E6824ABF5F', '0402'],
    ['14FD0829-29A0-4FF2-93B6-6E6B7824F3CC', '0407MASS'],
    ['7CF0CA22-B424-4385-A551-D6BC167F5895', '0408R'],
    ['F20CE0B7-BEC7-4CEF-BC75-31FC4069B91D', '0410PT'],
    ['94F361F2-3E8A-44BE-A987-B691A5168DCC', '0411MA'],
    ['2313872D-1E71-4C40-B27E-19B407D9A876', '0412MASS'],
    ['3E100049-7A7A-42CC-8A6D-6BB70CE8F83C', '0412PT'],
    ['91ABE629-50EE-4043-B4E8-5B2543E388B7', '0414PT'],
    ['FF8AA8A3-EC69-43A7-BFBD-3AAE6E460CA0', '0415PT'],
    ['6DB98812-C365-475C-AE03-DB09CEF55061', '0416MA'],
    ['FECFA1EF-989A-4D40-91F5-E1AA4A547A83', '0417MASS'],
    ['667938EA-8A57-4845-BCE5-316EE0637F33', '0417PT'],
    ['FE81B423-2D06-485D-A263-6EF6D9DAAD97', '0418MA'],
    ['BE042A9A-C375-4783-823C-D4ED27579B73', '0421'],
    ['E3FB1818-2211-4066-BB4F-34F628DC386A', '0433'],
    ['905E7BA6-9A67-46FC-8C9F-ED1CBDF7BFB2', '0440MASS'],
    ['E3BB27D6-967A-4113-A0CD-380CEA717FE4', '0448MA'],
    ['6B2BE4AF-C7B6-4EF2-B075-088AEEB0BFB8', '0456MASS'],
    ['D911802B-C650-479D-8ADE-23DB41E4AA18', '0475MA'],
    ['A1949E8B-FB0B-4A02-8DE4-8C4BB59D46D2', '0475PT'],
    ['17185238-184C-4DCC-AACB-5C54E028A9C4', '0497'],
    ['8F9C1AA2-995A-4C71-A399-F61A494C6793', '0499'],
    ['0A90188D-898F-47CB-858E-99B605FE5926', '0506'],
    ['7F335155-4C86-43A0-8CC3-77EAAC927C2C', '0508MA'],
    ['A94282FE-4B1D-4DEA-8C92-9247A49A8825', '0509'],
    ['8591BC40-544E-4A33-806B-24B6223D5051', '0519'],
    ['C993A6DB-7F73-4427-9909-76A3380A6E15', '0533MA'],
    ['52C8BF06-5E53-470E-90E8-08CF15D0F2E0', '0540MASS'],
    ['568410EC-0093-409E-B27C-411BDCC88012', '0542'],
    ['9E1936C0-F502-488D-AF3D-C9BB2AA9757C', '0548MA'],
    ['8105292B-CA5D-4CB8-8E59-9E70A3EBA81E', '0549PT'],
    ['7F56A76D-0974-4217-9DFD-89846C7EE24E', '0558MA'],
    ['9FABC952-2456-4CBC-86E0-9C9DF1791B49', '0559PT'],
    ['2FEAEE45-0D1C-49B2-9558-FCAB07F433F2', '0605MASS'],
    ['CE9DC9BD-D66F-493A-9FD8-6A8ED0D738B8', '0610MA'],
    ['19B06907-5D8F-40F9-9B14-A62358F09406', '0613MASS'],
    ['12AC19B2-AD55-4AE1-A0CD-8807D513EC54', '0617MASS'],
    ['3FD40431-E214-4350-B359-DC7500736E34', '0617R'],
    ['17D2B612-8921-4679-B07B-037A403D3BD5', '0618JS'],
    ['11AEFCFD-B582-47A8-9C56-FD18FD91D473', '0622MA'],
    ['F3828B40-4FD1-4C22-BF12-FE3920F325FD', '0632'],
    ['E50295E4-57F2-462D-A4E3-3BC232AB61B1', '0633MASS'],
    ['43BFB643-EF87-4FD0-9868-A1555836A5EB', '0634'],
    ['3BC47F2B-6F12-4860-9BBB-2F3CA7F4D477', '0634MASS'],
    ['4EEA8299-DDD7-451C-A8B0-7BC493E6390C', '0655MA'],
    ['B816C03D-4B7D-4E15-9F76-197CCD30C289', '0685'],
    ['2EBAC8DB-9BED-46BB-B52A-7D0CC2B4E039', '0690MA'],
    ['2452050F-9A11-4501-894C-5BBF69CCA7AA', '0701MA'],
    ['18FAC76B-76EA-4F17-9600-D5A8FCE6BC72', '1020PT'],
    ['4E72265C-BC36-469D-9F2A-4471F7212CD1', '1023'],
    ['16379795-1674-4635-9BD1-FD596F6BB594', '1023PT'],
    ['2E8C0DBB-B9A7-4556-8DDB-C779CC8198BA', '1026R'],
    ['4D5EE7AD-732B-4E17-A6DE-A99FE3D7B08F', '1029'],
    ['9F89D499-BBD5-43A3-A877-3F332C07AD50', '1032AMA'],
    ['AF3B1184-5E46-4B11-9B3D-49CBFEF6A74A', '1032BMASS'],
    ['A45CE1D1-53EF-4FDA-B1A3-4C09E6D7B7A9', '1032C'],
    ['7E649068-14BF-44DC-B86C-1CCD09FC1D41', '1035PT'],
    ['81BFB22B-B449-4D4D-8712-10A8CA40AD7B', '1037MASS'],
    ['0A23F65C-70CF-459F-A81F-551135244801', '1045A'],
    ['B76F354F-84F1-4A36-89AE-A028254F5866', '1045BPT'],
    ['E89702F1-0654-4269-BC2B-45A9F04305E4', '1050'],
    ['F32FD4F3-DCF0-41CE-B2C0-ADBCFCEAC2B2', '1060PT'],
    ['2B72CDA8-34D4-44B9-999B-7F16AB2AE3B3', '1061MA'],
    ['6151101A-4DAD-4EDA-A464-75F1AA5FC1BE', '1092MA'],
    ['537DCDF3-4A3E-4E80-9270-820E528BDEBE', '1038MASS'],
    ['79008118-F38B-4F24-89B2-3B1E186630B7', '1040'],
    ['5EE9FA7E-A48C-41DE-AE25-EF6244441850', '1045'],
    ['D9B8A925-EF5E-4FBA-A2B3-7100F71CB9C1', '1052MA'],
    ['F5E72323-76BF-4290-AB01-8F45BD9E8665', '1065'],
    ['5A9E67F8-78F1-4EB2-B039-286A4FDD1D8E', '1080PT'],
    ['DE27A918-7AA2-433A-8FEC-81093A489020', '1082PT'],
    ['78313624-3401-4C72-AB22-4624D04147A1', '1083PT'],
    ['7392FDB4-AD48-47AC-A47D-C934404CEE44', '1090'],
    ['091D70D7-31F4-4931-A728-E551366D8FB9', '1091MASS'],
]);

/**
 * Helper function to lookup JobCode by RefId
 * @param refId - The RefId (GUID) to lookup (case-insensitive)
 * @returns The JobCode if found, undefined otherwise
 */
export function getJobCodeByRefId(refId: string): string | undefined {
    if (!refId) {
        return undefined;
    }
    // Normalize to uppercase since GUIDs in the map are uppercase
    const normalizedRefId = refId.trim().toUpperCase();
    return JOB_CODE_REVERSE_LOOKUP.get(normalizedRefId);
}

